var __create = Object.create;
var __getProtoOf = Object.getPrototypeOf;
var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __toESM = (mod, isNodeMode, target) => {
  target = mod != null ? __create(__getProtoOf(mod)) : {};
  const to = isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target;
  for (let key of __getOwnPropNames(mod))
    if (!__hasOwnProp.call(to, key))
      __defProp(to, key, {
        get: () => mod[key],
        enumerable: true
      });
  return to;
};
var __commonJS = (cb, mod) => () => (mod || cb((mod = { exports: {} }).exports, mod), mod.exports);

// node_modules/mri/lib/index.js
var require_lib = __commonJS((exports, module) => {
  function toArr(any) {
    return any == null ? [] : Array.isArray(any) ? any : [any];
  }
  function toVal(out, key, val, opts) {
    var x, old = out[key], nxt = ~opts.string.indexOf(key) ? val == null || val === true ? "" : String(val) : typeof val === "boolean" ? val : ~opts.boolean.indexOf(key) ? val === "false" ? false : val === "true" || (out._.push((x = +val, x * 0 === 0) ? x : val), !!val) : (x = +val, x * 0 === 0) ? x : val;
    out[key] = old == null ? nxt : Array.isArray(old) ? old.concat(nxt) : [old, nxt];
  }
  module.exports = function(args, opts) {
    args = args || [];
    opts = opts || {};
    var k, arr, arg, name, val, out = { _: [] };
    var i = 0, j = 0, idx = 0, len = args.length;
    const alibi = opts.alias !== undefined;
    const strict = opts.unknown !== undefined;
    const defaults = opts.default !== undefined;
    opts.alias = opts.alias || {};
    opts.string = toArr(opts.string);
    opts.boolean = toArr(opts.boolean);
    if (alibi) {
      for (k in opts.alias) {
        arr = opts.alias[k] = toArr(opts.alias[k]);
        for (i = 0;i < arr.length; i++) {
          (opts.alias[arr[i]] = arr.concat(k)).splice(i, 1);
        }
      }
    }
    for (i = opts.boolean.length;i-- > 0; ) {
      arr = opts.alias[opts.boolean[i]] || [];
      for (j = arr.length;j-- > 0; )
        opts.boolean.push(arr[j]);
    }
    for (i = opts.string.length;i-- > 0; ) {
      arr = opts.alias[opts.string[i]] || [];
      for (j = arr.length;j-- > 0; )
        opts.string.push(arr[j]);
    }
    if (defaults) {
      for (k in opts.default) {
        name = typeof opts.default[k];
        arr = opts.alias[k] = opts.alias[k] || [];
        if (opts[name] !== undefined) {
          opts[name].push(k);
          for (i = 0;i < arr.length; i++) {
            opts[name].push(arr[i]);
          }
        }
      }
    }
    const keys = strict ? Object.keys(opts.alias) : [];
    for (i = 0;i < len; i++) {
      arg = args[i];
      if (arg === "--") {
        out._ = out._.concat(args.slice(++i));
        break;
      }
      for (j = 0;j < arg.length; j++) {
        if (arg.charCodeAt(j) !== 45)
          break;
      }
      if (j === 0) {
        out._.push(arg);
      } else if (arg.substring(j, j + 3) === "no-") {
        name = arg.substring(j + 3);
        if (strict && !~keys.indexOf(name)) {
          return opts.unknown(arg);
        }
        out[name] = false;
      } else {
        for (idx = j + 1;idx < arg.length; idx++) {
          if (arg.charCodeAt(idx) === 61)
            break;
        }
        name = arg.substring(j, idx);
        val = arg.substring(++idx) || (i + 1 === len || ("" + args[i + 1]).charCodeAt(0) === 45 || args[++i]);
        arr = j === 2 ? [name] : name;
        for (idx = 0;idx < arr.length; idx++) {
          name = arr[idx];
          if (strict && !~keys.indexOf(name))
            return opts.unknown("-".repeat(j) + name);
          toVal(out, name, idx + 1 < arr.length || val, opts);
        }
      }
    }
    if (defaults) {
      for (k in opts.default) {
        if (out[k] === undefined) {
          out[k] = opts.default[k];
        }
      }
    }
    if (alibi) {
      for (k in out) {
        arr = opts.alias[k] || [];
        while (arr.length > 0) {
          out[arr.shift()] = out[k];
        }
      }
    }
    return out;
  };
});

// node_modules/picocolors/picocolors.js
var require_picocolors = __commonJS((exports, module) => {
  var p = process || {};
  var argv = p.argv || [];
  var env = p.env || {};
  var isColorSupported = !(!!env.NO_COLOR || argv.includes("--no-color")) && (!!env.FORCE_COLOR || argv.includes("--color") || p.platform === "win32" || (p.stdout || {}).isTTY && env.TERM !== "dumb" || !!env.CI);
  var formatter = (open, close, replace = open) => (input) => {
    let string = "" + input, index = string.indexOf(close, open.length);
    return ~index ? open + replaceClose(string, close, replace, index) + close : open + string + close;
  };
  var replaceClose = (string, close, replace, index) => {
    let result = "", cursor2 = 0;
    do {
      result += string.substring(cursor2, index) + replace;
      cursor2 = index + close.length;
      index = string.indexOf(close, cursor2);
    } while (~index);
    return result + string.substring(cursor2);
  };
  var createColors = (enabled = isColorSupported) => {
    let f = enabled ? formatter : () => String;
    return {
      isColorSupported: enabled,
      reset: f("\x1B[0m", "\x1B[0m"),
      bold: f("\x1B[1m", "\x1B[22m", "\x1B[22m\x1B[1m"),
      dim: f("\x1B[2m", "\x1B[22m", "\x1B[22m\x1B[2m"),
      italic: f("\x1B[3m", "\x1B[23m"),
      underline: f("\x1B[4m", "\x1B[24m"),
      inverse: f("\x1B[7m", "\x1B[27m"),
      hidden: f("\x1B[8m", "\x1B[28m"),
      strikethrough: f("\x1B[9m", "\x1B[29m"),
      black: f("\x1B[30m", "\x1B[39m"),
      red: f("\x1B[31m", "\x1B[39m"),
      green: f("\x1B[32m", "\x1B[39m"),
      yellow: f("\x1B[33m", "\x1B[39m"),
      blue: f("\x1B[34m", "\x1B[39m"),
      magenta: f("\x1B[35m", "\x1B[39m"),
      cyan: f("\x1B[36m", "\x1B[39m"),
      white: f("\x1B[37m", "\x1B[39m"),
      gray: f("\x1B[90m", "\x1B[39m"),
      bgBlack: f("\x1B[40m", "\x1B[49m"),
      bgRed: f("\x1B[41m", "\x1B[49m"),
      bgGreen: f("\x1B[42m", "\x1B[49m"),
      bgYellow: f("\x1B[43m", "\x1B[49m"),
      bgBlue: f("\x1B[44m", "\x1B[49m"),
      bgMagenta: f("\x1B[45m", "\x1B[49m"),
      bgCyan: f("\x1B[46m", "\x1B[49m"),
      bgWhite: f("\x1B[47m", "\x1B[49m"),
      blackBright: f("\x1B[90m", "\x1B[39m"),
      redBright: f("\x1B[91m", "\x1B[39m"),
      greenBright: f("\x1B[92m", "\x1B[39m"),
      yellowBright: f("\x1B[93m", "\x1B[39m"),
      blueBright: f("\x1B[94m", "\x1B[39m"),
      magentaBright: f("\x1B[95m", "\x1B[39m"),
      cyanBright: f("\x1B[96m", "\x1B[39m"),
      whiteBright: f("\x1B[97m", "\x1B[39m"),
      bgBlackBright: f("\x1B[100m", "\x1B[49m"),
      bgRedBright: f("\x1B[101m", "\x1B[49m"),
      bgGreenBright: f("\x1B[102m", "\x1B[49m"),
      bgYellowBright: f("\x1B[103m", "\x1B[49m"),
      bgBlueBright: f("\x1B[104m", "\x1B[49m"),
      bgMagentaBright: f("\x1B[105m", "\x1B[49m"),
      bgCyanBright: f("\x1B[106m", "\x1B[49m"),
      bgWhiteBright: f("\x1B[107m", "\x1B[49m")
    };
  };
  module.exports = createColors();
  module.exports.createColors = createColors;
});

// node_modules/emoji-regex/index.js
var require_emoji_regex = __commonJS((exports, module) => {
  module.exports = () => {
    return /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE89\uDE8F-\uDEC2\uDEC6\uDECE-\uDEDC\uDEDF-\uDEE9]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
  };
});

// src/CLI.ts
var import_mri = __toESM(require_lib(), 1);
import { EventEmitter } from "node:events";

// src/utils.ts
import process2 from "node:process";
function removeBrackets(v) {
  return v.replace(/[<[].+/, "").trim();
}
function findAllBrackets(v) {
  const ANGLED_BRACKET_RE_GLOBAL = /<([^>]+)>/g;
  const SQUARE_BRACKET_RE_GLOBAL = /\[([^\]]+)\]/g;
  const res = [];
  const parse = (match) => {
    let variadic = false;
    let value = match[1];
    if (value.startsWith("...")) {
      value = value.slice(3);
      variadic = true;
    }
    return {
      required: match[0].startsWith("<"),
      value,
      variadic
    };
  };
  let angledMatch;
  while (angledMatch = ANGLED_BRACKET_RE_GLOBAL.exec(v)) {
    res.push(parse(angledMatch));
  }
  let squareMatch;
  while (squareMatch = SQUARE_BRACKET_RE_GLOBAL.exec(v)) {
    res.push(parse(squareMatch));
  }
  return res;
}
function getMriOptions(options) {
  const result = { alias: {}, boolean: [] };
  for (const [index, option] of options.entries()) {
    if (option.names.length > 1) {
      result.alias[option.names[0]] = option.names.slice(1);
    }
    if (option.isBoolean) {
      if (option.negated) {
        const hasStringTypeOption = options.some((o, i) => {
          return i !== index && o.names.some((name) => option.names.includes(name)) && typeof o.required === "boolean";
        });
        if (!hasStringTypeOption) {
          result.boolean.push(option.names[0]);
        }
      } else {
        result.boolean.push(option.names[0]);
      }
    }
  }
  return result;
}
function findLongest(arr) {
  return arr.sort((a, b) => {
    return a.length > b.length ? -1 : 1;
  })[0];
}
function padRight(str, length) {
  return str.length >= length ? str : `${str}${" ".repeat(length - str.length)}`;
}
function camelcase(input) {
  return input.replace(/([a-z])-([a-z])/g, (_, p1, p2) => {
    return p1 + p2.toUpperCase();
  });
}
function setDotProp(obj, keys, val) {
  let i = 0;
  const length = keys.length;
  let t = obj;
  let x;
  for (;i < length; ++i) {
    x = t[keys[i]];
    t = t[keys[i]] = i === length - 1 ? val : x != null ? x : !!~keys[i + 1].indexOf(".") || !(+keys[i + 1] > -1) ? {} : [];
  }
}
function setByType(obj, transforms) {
  for (const key of Object.keys(transforms)) {
    const transform = transforms[key];
    if (transform.shouldTransform) {
      obj[key] = Array.prototype.concat.call([], obj[key]);
      if (typeof transform.transformFunction === "function") {
        obj[key] = obj[key].map(transform.transformFunction);
      }
    }
  }
}
function getFileName(input) {
  const m = /([^\\/]+)$/.exec(input);
  return m ? m[1] : "";
}
function camelcaseOptionName(name) {
  return name.split(".").map((v, i) => {
    return i === 0 ? camelcase(v) : v;
  }).join(".");
}

class ClappError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}
function isUnicodeSupported() {
  const { env } = process2;
  const { TERM, TERM_PROGRAM } = env;
  if (process2.platform !== "win32") {
    return TERM !== "linux";
  }
  return Boolean(env.WT_SESSION) || Boolean(env.TERMINUS_SUBLIME) || env.ConEmuTask === "{cmd::Cmder}" || TERM_PROGRAM === "Terminus-Sublime" || TERM_PROGRAM === "vscode" || TERM === "xterm-256color" || TERM === "alacritty" || TERM === "rxvt-unicode" || TERM === "rxvt-unicode-256color" || env.TERMINAL_EMULATOR === "JetBrains-JediTerm";
}
var ESC = "\x1B";
var CSI = `${ESC}[`;
var beep = "\x07";
var cursor = {
  to(x, y) {
    if (!y)
      return `${CSI}${x + 1}G`;
    return `${CSI}${y + 1};${x + 1}H`;
  },
  move(x, y) {
    let ret = "";
    if (x < 0)
      ret += `${CSI}${-x}D`;
    else if (x > 0)
      ret += `${CSI}${x}C`;
    if (y < 0)
      ret += `${CSI}${-y}A`;
    else if (y > 0)
      ret += `${CSI}${y}B`;
    return ret;
  },
  up: (count = 1) => `${CSI}${count}A`,
  down: (count = 1) => `${CSI}${count}B`,
  forward: (count = 1) => `${CSI}${count}C`,
  backward: (count = 1) => `${CSI}${count}D`,
  nextLine: (count = 1) => `${CSI}E`.repeat(count),
  prevLine: (count = 1) => `${CSI}F`.repeat(count),
  left: `${CSI}G`,
  hide: `${CSI}?25l`,
  show: `${CSI}?25h`,
  save: `${ESC}7`,
  restore: `${ESC}8`
};
var scroll = {
  up: (count = 1) => `${CSI}S`.repeat(count),
  down: (count = 1) => `${CSI}T`.repeat(count)
};
var erase = {
  screen: `${CSI}2J`,
  up: (count = 1) => `${CSI}1J`.repeat(count),
  down: (count = 1) => `${CSI}J`.repeat(count),
  line: `${CSI}2K`,
  lineEnd: `${CSI}K`,
  lineStart: `${CSI}1K`,
  lines(count) {
    let clear = "";
    for (let i = 0;i < count; i++)
      clear += this.line + (i < count - 1 ? cursor.up() : "");
    if (count)
      clear += cursor.left;
    return clear;
  }
};
var clear = {
  screen: `${ESC}c`
};

// src/Option.ts
class Option {
  rawName;
  description;
  name;
  names;
  isBoolean;
  required;
  config;
  negated;
  constructor(rawName, description, config) {
    this.rawName = rawName;
    this.description = description;
    this.config = Object.assign({}, config);
    rawName = rawName.replace(/\.\*/g, "");
    this.negated = false;
    this.names = removeBrackets(rawName).split(",").map((v) => {
      let name = v.trim().replace(/^-{1,2}/, "");
      if (name.startsWith("no-")) {
        this.negated = true;
        name = name.replace(/^no-/, "");
      }
      return camelcaseOptionName(name);
    }).sort((a, b) => a.length > b.length ? 1 : -1);
    this.name = this.names[this.names.length - 1];
    if (this.negated && this.config.default == null) {
      this.config.default = true;
    }
    if (rawName.includes("<")) {
      this.required = true;
    } else if (rawName.includes("[")) {
      this.required = false;
    } else {
      this.isBoolean = true;
    }
  }
}

// src/runtimes/bun.ts
import process3 from "node:process";
var processArgs = process3.argv;
var platformInfo = `${process3.platform}-${process3.arch} bun-v${typeof Bun !== "undefined" ? Bun.version : "unknown"}`;

// src/runtimes/node.ts
import process4 from "node:process";
var processArgs2 = process4.argv;
var platformInfo2 = `${process4.platform}-${process4.arch} node-${process4.version}`;

// src/Command.ts
class Command {
  rawName;
  description;
  config;
  cli;
  options;
  aliasNames;
  name;
  args;
  commandAction;
  usageText;
  versionNumber;
  examples;
  helpCallback;
  globalCommand;
  constructor(rawName, description, config, cli) {
    this.rawName = rawName;
    this.description = description;
    this.config = config;
    this.cli = cli;
    this.options = [];
    this.aliasNames = [];
    this.name = removeBrackets(rawName);
    this.args = findAllBrackets(rawName);
    this.examples = [];
    if (!config) {
      this.config = {};
    }
  }
  usage(text) {
    this.usageText = text;
    return this;
  }
  allowUnknownOptions() {
    this.config.allowUnknownOptions = true;
    return this;
  }
  ignoreOptionDefaultValue() {
    this.config.ignoreOptionDefaultValue = true;
    return this;
  }
  version(version, customFlags = "-v, --version") {
    this.versionNumber = version;
    this.option(customFlags, "Display version number");
    return this;
  }
  example(example) {
    this.examples.push(example);
    return this;
  }
  option(rawName, description, config) {
    const option = new Option(rawName, description, config);
    this.options.push(option);
    return this;
  }
  alias(name) {
    this.aliasNames.push(name);
    return this;
  }
  action(callback) {
    this.commandAction = callback;
    return this;
  }
  isMatched(name) {
    return this.name === name || this.aliasNames.includes(name);
  }
  get isDefaultCommand() {
    return this.name === "" || this.aliasNames.includes("!");
  }
  get isGlobalCommand() {
    return this instanceof GlobalCommand;
  }
  hasOption(name) {
    name = name.split(".")[0];
    return !!this.options.find((option) => {
      return option.names.includes(name);
    });
  }
  outputHelp() {
    const { name, commands } = this.cli;
    const {
      versionNumber,
      options: globalOptions,
      helpCallback
    } = this.cli.globalCommand;
    let sections = [
      {
        body: `${name}${versionNumber ? `/${versionNumber}` : ""}`
      }
    ];
    sections.push({
      title: "Usage",
      body: `  $ ${name} ${this.usageText || this.rawName}`
    });
    const showCommands = (this.isGlobalCommand || this.isDefaultCommand) && commands.length > 0;
    if (showCommands) {
      const longestCommandName = findLongest(commands.map((command) => command.rawName));
      sections.push({
        title: "Commands",
        body: commands.map((command) => {
          return `  ${padRight(command.rawName, longestCommandName.length)}  ${command.description}`;
        }).join(`
`)
      });
      sections.push({
        title: `For more info, run any command with the \`--help\` flag`,
        body: commands.map((command) => `  $ ${name}${command.name === "" ? "" : ` ${command.name}`} --help`).join(`
`)
      });
    }
    let options = this.isGlobalCommand ? globalOptions : [...this.options, ...globalOptions || []];
    if (!this.isGlobalCommand && !this.isDefaultCommand) {
      options = options.filter((option) => option.name !== "version");
    }
    if (options.length > 0) {
      const longestOptionName = findLongest(options.map((option) => option.rawName));
      sections.push({
        title: "Options",
        body: options.map((option) => {
          return `  ${padRight(option.rawName, longestOptionName.length)}  ${option.description} ${option.config.default === undefined ? "" : `(default: ${option.config.default})`}`;
        }).join(`
`)
      });
    }
    if (this.examples.length > 0) {
      sections.push({
        title: "Examples",
        body: this.examples.map((example) => {
          if (typeof example === "function") {
            return example(name);
          }
          return example;
        }).join(`
`)
      });
    }
    if (helpCallback) {
      sections = helpCallback(sections) || sections;
    }
    console.log(sections.map((section) => {
      return section.title ? `${section.title}:
${section.body}` : section.body;
    }).join(`

`));
  }
  outputVersion() {
    const { name } = this.cli;
    const { versionNumber } = this.cli.globalCommand;
    if (versionNumber) {
      let platformInfo3;
      if (Bun) {
        platformInfo3 = platformInfo;
      } else {
        platformInfo3 = platformInfo2;
      }
      console.log(`${name}/${versionNumber} ${platformInfo3}`);
    }
  }
  checkRequiredArgs() {
    const minimalArgsCount = this.args.filter((arg) => arg.required).length;
    if (this.cli.args.length < minimalArgsCount) {
      throw new ClappError(`missing required args for command \`${this.rawName}\``);
    }
  }
  checkUnknownOptions() {
    const { options, globalCommand } = this.cli;
    if (!this.config.allowUnknownOptions) {
      for (const name of Object.keys(options)) {
        if (name !== "--" && !this.hasOption(name) && !globalCommand.hasOption(name)) {
          throw new ClappError(`Unknown option \`${name.length > 1 ? `--${name}` : `-${name}`}\``);
        }
      }
    }
  }
  checkOptionValue() {
    const { options: parsedOptions, globalCommand } = this.cli;
    const options = [...globalCommand.options, ...this.options];
    for (const option of options) {
      const value = parsedOptions[option.name.split(".")[0]];
      if (option.required) {
        const hasNegated = options.some((o) => o.negated && o.names.includes(option.name));
        if (value === true || value === false && !hasNegated) {
          throw new ClappError(`option \`${option.rawName}\` value is missing`);
        }
      }
    }
  }
}

class GlobalCommand extends Command {
  constructor(cli) {
    super("@@global@@", "", {}, cli);
  }
}
var Command_default = Command;

// src/CLI.ts
class CLI extends EventEmitter {
  name;
  commands;
  globalCommand;
  matchedCommand;
  matchedCommandName;
  rawArgs;
  args;
  options;
  showHelpOnExit;
  showVersionOnExit;
  constructor(name = "") {
    super();
    this.name = name;
    this.commands = [];
    this.rawArgs = [];
    this.args = [];
    this.options = {};
    this.globalCommand = new GlobalCommand(this);
    this.globalCommand.usage("<command> [options]");
  }
  usage(text) {
    this.globalCommand.usage(text);
    return this;
  }
  command(rawName, description, config) {
    if (!config) {
      config = {};
    }
    const command = new Command_default(rawName, description || "", config, this);
    command.globalCommand = this.globalCommand;
    this.commands.push(command);
    return command;
  }
  option(rawName, description, config) {
    this.globalCommand.option(rawName, description, config);
    return this;
  }
  help(callback) {
    this.globalCommand.option("-h, --help", "Display this message");
    this.globalCommand.helpCallback = callback;
    this.showHelpOnExit = true;
    return this;
  }
  version(version, customFlags = "-v, --version") {
    this.globalCommand.version(version, customFlags);
    this.showVersionOnExit = true;
    return this;
  }
  example(example) {
    this.globalCommand.example(example);
    return this;
  }
  outputHelp() {
    if (this.matchedCommand) {
      this.matchedCommand.outputHelp();
    } else {
      this.globalCommand.outputHelp();
    }
  }
  outputVersion() {
    this.globalCommand.outputVersion();
  }
  setParsedInfo({ args, options }, matchedCommand, matchedCommandName) {
    this.args = args;
    this.options = options;
    if (matchedCommand) {
      this.matchedCommand = matchedCommand;
    }
    if (matchedCommandName) {
      this.matchedCommandName = matchedCommandName;
    }
    return this;
  }
  unsetMatchedCommand() {
    this.matchedCommand = undefined;
    this.matchedCommandName = undefined;
  }
  parse(argv = processArgs2, {
    run = true
  } = {}) {
    this.rawArgs = argv;
    if (!this.name) {
      this.name = argv[1] ? getFileName(argv[1]) : "cli";
    }
    let shouldParse = true;
    for (const command of this.commands) {
      const parsed = this.mri(argv.slice(2), command);
      const commandName = parsed.args[0];
      if (command.isMatched(commandName)) {
        shouldParse = false;
        const parsedInfo = {
          ...parsed,
          args: parsed.args.slice(1)
        };
        this.setParsedInfo(parsedInfo, command, commandName);
        this.emit(`command:${commandName}`, command);
      }
    }
    if (shouldParse) {
      for (const command of this.commands) {
        if (command.name === "") {
          shouldParse = false;
          const parsed = this.mri(argv.slice(2), command);
          this.setParsedInfo(parsed, command);
          this.emit(`command:!`, command);
        }
      }
    }
    if (shouldParse) {
      const parsed = this.mri(argv.slice(2));
      this.setParsedInfo(parsed);
    }
    if (this.options.help && this.showHelpOnExit) {
      this.outputHelp();
      run = false;
      this.unsetMatchedCommand();
    }
    if (this.options.version && this.showVersionOnExit && this.matchedCommandName == null) {
      this.outputVersion();
      run = false;
      this.unsetMatchedCommand();
    }
    const parsedArgv = { args: this.args, options: this.options };
    if (run) {
      this.runMatchedCommand();
    }
    if (!this.matchedCommand && this.args[0]) {
      this.emit("command:*");
    }
    return parsedArgv;
  }
  mri(argv, command) {
    const cliOptions = [
      ...this.globalCommand.options,
      ...command ? command.options : []
    ];
    const mriOptions = getMriOptions(cliOptions);
    let argsAfterDoubleDashes = [];
    const doubleDashesIndex = argv.indexOf("--");
    if (doubleDashesIndex > -1) {
      argsAfterDoubleDashes = argv.slice(doubleDashesIndex + 1);
      argv = argv.slice(0, doubleDashesIndex);
    }
    let parsed = import_mri.default(argv, mriOptions);
    parsed = Object.keys(parsed).reduce((res, name) => {
      return {
        ...res,
        [camelcaseOptionName(name)]: parsed[name]
      };
    }, { _: [] });
    const args = parsed._;
    const options = {
      "--": argsAfterDoubleDashes
    };
    const ignoreDefault = command && command.config.ignoreOptionDefaultValue ? command.config.ignoreOptionDefaultValue : this.globalCommand.config.ignoreOptionDefaultValue;
    const transforms = Object.create(null);
    for (const cliOption of cliOptions) {
      if (!ignoreDefault && cliOption.config.default !== undefined) {
        for (const name of cliOption.names) {
          options[name] = cliOption.config.default;
        }
      }
      if (Array.isArray(cliOption.config.type)) {
        if (transforms[cliOption.name] === undefined) {
          transforms[cliOption.name] = Object.create(null);
          transforms[cliOption.name].shouldTransform = true;
          transforms[cliOption.name].transformFunction = cliOption.config.type[0];
        }
      }
    }
    for (const key of Object.keys(parsed)) {
      if (key !== "_") {
        const keys = key.split(".");
        setDotProp(options, keys, parsed[key]);
        setByType(options, transforms);
      }
    }
    return {
      args,
      options
    };
  }
  runMatchedCommand() {
    const { args, options, matchedCommand: command } = this;
    if (!command || !command.commandAction)
      return;
    command.checkUnknownOptions();
    command.checkOptionValue();
    command.checkRequiredArgs();
    const actionArgs = [];
    command.args.forEach((arg, index) => {
      if (arg.variadic) {
        actionArgs.push(args.slice(index));
      } else {
        actionArgs.push(args[index]);
      }
    });
    actionArgs.push(options);
    return command.commandAction.apply(this, actionArgs);
  }
}
var cli = (name = "") => new CLI(name);
// src/prompts/autocomplete.ts
var import_picocolors6 = __toESM(require_picocolors(), 1);
// src/utils/index.ts
import process5, { stdin, stdout } from "node:process";
import * as readline from "node:readline";
import { ReadStream, WriteStream } from "node:tty";

// src/utils/settings.ts
var actions = ["up", "down", "left", "right", "space", "enter", "cancel"];
var settings = {
  actions: new Set(actions),
  aliases: new Map([
    ["k", "up"],
    ["j", "down"],
    ["h", "left"],
    ["l", "right"],
    ["\x03", "cancel"],
    ["escape", "cancel"]
  ]),
  messages: {
    cancel: "Canceled",
    error: "Something went wrong"
  }
};
function updateSettings(updates) {
  if (updates.aliases !== undefined) {
    const aliases = updates.aliases;
    for (const alias in aliases) {
      if (!Object.hasOwn(aliases, alias))
        continue;
      const action = aliases[alias];
      if (!settings.actions.has(action))
        continue;
      if (!settings.aliases.has(alias)) {
        settings.aliases.set(alias, action);
      }
    }
  }
  if (updates.messages !== undefined) {
    const messages = updates.messages;
    if (messages.cancel !== undefined) {
      settings.messages.cancel = messages.cancel;
    }
    if (messages.error !== undefined) {
      settings.messages.error = messages.error;
    }
  }
}
function isActionKey(key, action) {
  if (typeof key === "string") {
    return settings.aliases.get(key) === action;
  }
  for (const value of key) {
    if (value === undefined)
      continue;
    if (isActionKey(value, action)) {
      return true;
    }
  }
  return false;
}
// src/utils/string.ts
function diffLines(a, b) {
  if (a === b)
    return [];
  const aLines = a.split(`
`);
  const bLines = b.split(`
`);
  const diff = [];
  for (let i = 0;i < Math.max(aLines.length, bLines.length); i++) {
    if (aLines[i] !== bLines[i])
      diff.push(i);
  }
  return diff;
}

// src/utils/index.ts
var isWindows = process5.platform.startsWith("win");
var CANCEL_SYMBOL = Symbol("clapp:cancel");
function isCancel(value) {
  return value === CANCEL_SYMBOL;
}
function setRawMode(input, value) {
  const i = input;
  if (i.isTTY)
    i.setRawMode(value);
}
function block(options) {
  const {
    input = stdin,
    output = stdout,
    overwrite = true,
    hideCursor = true
  } = options || {};
  const rl = readline.createInterface({
    input,
    output,
    prompt: "",
    tabSize: 1
  });
  readline.emitKeypressEvents(input, rl);
  if (input instanceof ReadStream && input.isTTY) {
    input.setRawMode(true);
  }
  const clear2 = (data, { name, sequence }) => {
    const str = String(data);
    if (isActionKey([str, name, sequence], "cancel")) {
      if (hideCursor)
        output.write(cursor.show);
      process5.exit(0);
      return;
    }
    if (!overwrite)
      return;
    const dx = name === "return" ? 0 : -1;
    const dy = name === "return" ? -1 : 0;
    readline.moveCursor(output, dx, dy, () => {
      readline.clearLine(output, 1, () => {
        input.once("keypress", clear2);
      });
    });
  };
  if (hideCursor)
    output.write(cursor.hide);
  input.once("keypress", clear2);
  return () => {
    input.off("keypress", clear2);
    if (hideCursor)
      output.write(cursor.show);
    if (input instanceof ReadStream && input.isTTY && !isWindows) {
      input.setRawMode(false);
    }
    rl.terminal = false;
    rl.close();
  };
}
function getColumns(output) {
  if (output instanceof WriteStream && output.columns) {
    return output.columns;
  }
  return 80;
}
// src/core/prompts/autocomplete.ts
var import_picocolors = __toESM(require_picocolors(), 1);

// src/core/prompts/prompt.ts
import process6, { stdin as stdin2, stdout as stdout2 } from "node:process";
import readline2 from "node:readline";

// node_modules/ansi-regex/index.js
function ansiRegex({ onlyFirst = false } = {}) {
  const ST = "(?:\\u0007|\\u001B\\u005C|\\u009C)";
  const osc = `(?:\\u001B\\][\\s\\S]*?${ST})`;
  const csi = "[\\u001B\\u009B][[\\]()#;?]*(?:\\d{1,4}(?:[;:]\\d{0,4})*)?[\\dA-PR-TZcf-nq-uy=><~]";
  const pattern = `${osc}|${csi}`;
  return new RegExp(pattern, onlyFirst ? undefined : "g");
}

// node_modules/strip-ansi/index.js
var regex = ansiRegex();
function stripAnsi(string2) {
  if (typeof string2 !== "string") {
    throw new TypeError(`Expected a \`string\`, got \`${typeof string2}\``);
  }
  return string2.replace(regex, "");
}

// node_modules/get-east-asian-width/lookup.js
function isAmbiguous(x) {
  return x === 161 || x === 164 || x === 167 || x === 168 || x === 170 || x === 173 || x === 174 || x >= 176 && x <= 180 || x >= 182 && x <= 186 || x >= 188 && x <= 191 || x === 198 || x === 208 || x === 215 || x === 216 || x >= 222 && x <= 225 || x === 230 || x >= 232 && x <= 234 || x === 236 || x === 237 || x === 240 || x === 242 || x === 243 || x >= 247 && x <= 250 || x === 252 || x === 254 || x === 257 || x === 273 || x === 275 || x === 283 || x === 294 || x === 295 || x === 299 || x >= 305 && x <= 307 || x === 312 || x >= 319 && x <= 322 || x === 324 || x >= 328 && x <= 331 || x === 333 || x === 338 || x === 339 || x === 358 || x === 359 || x === 363 || x === 462 || x === 464 || x === 466 || x === 468 || x === 470 || x === 472 || x === 474 || x === 476 || x === 593 || x === 609 || x === 708 || x === 711 || x >= 713 && x <= 715 || x === 717 || x === 720 || x >= 728 && x <= 731 || x === 733 || x === 735 || x >= 768 && x <= 879 || x >= 913 && x <= 929 || x >= 931 && x <= 937 || x >= 945 && x <= 961 || x >= 963 && x <= 969 || x === 1025 || x >= 1040 && x <= 1103 || x === 1105 || x === 8208 || x >= 8211 && x <= 8214 || x === 8216 || x === 8217 || x === 8220 || x === 8221 || x >= 8224 && x <= 8226 || x >= 8228 && x <= 8231 || x === 8240 || x === 8242 || x === 8243 || x === 8245 || x === 8251 || x === 8254 || x === 8308 || x === 8319 || x >= 8321 && x <= 8324 || x === 8364 || x === 8451 || x === 8453 || x === 8457 || x === 8467 || x === 8470 || x === 8481 || x === 8482 || x === 8486 || x === 8491 || x === 8531 || x === 8532 || x >= 8539 && x <= 8542 || x >= 8544 && x <= 8555 || x >= 8560 && x <= 8569 || x === 8585 || x >= 8592 && x <= 8601 || x === 8632 || x === 8633 || x === 8658 || x === 8660 || x === 8679 || x === 8704 || x === 8706 || x === 8707 || x === 8711 || x === 8712 || x === 8715 || x === 8719 || x === 8721 || x === 8725 || x === 8730 || x >= 8733 && x <= 8736 || x === 8739 || x === 8741 || x >= 8743 && x <= 8748 || x === 8750 || x >= 8756 && x <= 8759 || x === 8764 || x === 8765 || x === 8776 || x === 8780 || x === 8786 || x === 8800 || x === 8801 || x >= 8804 && x <= 8807 || x === 8810 || x === 8811 || x === 8814 || x === 8815 || x === 8834 || x === 8835 || x === 8838 || x === 8839 || x === 8853 || x === 8857 || x === 8869 || x === 8895 || x === 8978 || x >= 9312 && x <= 9449 || x >= 9451 && x <= 9547 || x >= 9552 && x <= 9587 || x >= 9600 && x <= 9615 || x >= 9618 && x <= 9621 || x === 9632 || x === 9633 || x >= 9635 && x <= 9641 || x === 9650 || x === 9651 || x === 9654 || x === 9655 || x === 9660 || x === 9661 || x === 9664 || x === 9665 || x >= 9670 && x <= 9672 || x === 9675 || x >= 9678 && x <= 9681 || x >= 9698 && x <= 9701 || x === 9711 || x === 9733 || x === 9734 || x === 9737 || x === 9742 || x === 9743 || x === 9756 || x === 9758 || x === 9792 || x === 9794 || x === 9824 || x === 9825 || x >= 9827 && x <= 9829 || x >= 9831 && x <= 9834 || x === 9836 || x === 9837 || x === 9839 || x === 9886 || x === 9887 || x === 9919 || x >= 9926 && x <= 9933 || x >= 9935 && x <= 9939 || x >= 9941 && x <= 9953 || x === 9955 || x === 9960 || x === 9961 || x >= 9963 && x <= 9969 || x === 9972 || x >= 9974 && x <= 9977 || x === 9979 || x === 9980 || x === 9982 || x === 9983 || x === 10045 || x >= 10102 && x <= 10111 || x >= 11094 && x <= 11097 || x >= 12872 && x <= 12879 || x >= 57344 && x <= 63743 || x >= 65024 && x <= 65039 || x === 65533 || x >= 127232 && x <= 127242 || x >= 127248 && x <= 127277 || x >= 127280 && x <= 127337 || x >= 127344 && x <= 127373 || x === 127375 || x === 127376 || x >= 127387 && x <= 127404 || x >= 917760 && x <= 917999 || x >= 983040 && x <= 1048573 || x >= 1048576 && x <= 1114109;
}
function isFullWidth(x) {
  return x === 12288 || x >= 65281 && x <= 65376 || x >= 65504 && x <= 65510;
}
function isWide(x) {
  return x >= 4352 && x <= 4447 || x === 8986 || x === 8987 || x === 9001 || x === 9002 || x >= 9193 && x <= 9196 || x === 9200 || x === 9203 || x === 9725 || x === 9726 || x === 9748 || x === 9749 || x >= 9776 && x <= 9783 || x >= 9800 && x <= 9811 || x === 9855 || x >= 9866 && x <= 9871 || x === 9875 || x === 9889 || x === 9898 || x === 9899 || x === 9917 || x === 9918 || x === 9924 || x === 9925 || x === 9934 || x === 9940 || x === 9962 || x === 9970 || x === 9971 || x === 9973 || x === 9978 || x === 9981 || x === 9989 || x === 9994 || x === 9995 || x === 10024 || x === 10060 || x === 10062 || x >= 10067 && x <= 10069 || x === 10071 || x >= 10133 && x <= 10135 || x === 10160 || x === 10175 || x === 11035 || x === 11036 || x === 11088 || x === 11093 || x >= 11904 && x <= 11929 || x >= 11931 && x <= 12019 || x >= 12032 && x <= 12245 || x >= 12272 && x <= 12287 || x >= 12289 && x <= 12350 || x >= 12353 && x <= 12438 || x >= 12441 && x <= 12543 || x >= 12549 && x <= 12591 || x >= 12593 && x <= 12686 || x >= 12688 && x <= 12773 || x >= 12783 && x <= 12830 || x >= 12832 && x <= 12871 || x >= 12880 && x <= 42124 || x >= 42128 && x <= 42182 || x >= 43360 && x <= 43388 || x >= 44032 && x <= 55203 || x >= 63744 && x <= 64255 || x >= 65040 && x <= 65049 || x >= 65072 && x <= 65106 || x >= 65108 && x <= 65126 || x >= 65128 && x <= 65131 || x >= 94176 && x <= 94180 || x === 94192 || x === 94193 || x >= 94208 && x <= 100343 || x >= 100352 && x <= 101589 || x >= 101631 && x <= 101640 || x >= 110576 && x <= 110579 || x >= 110581 && x <= 110587 || x === 110589 || x === 110590 || x >= 110592 && x <= 110882 || x === 110898 || x >= 110928 && x <= 110930 || x === 110933 || x >= 110948 && x <= 110951 || x >= 110960 && x <= 111355 || x >= 119552 && x <= 119638 || x >= 119648 && x <= 119670 || x === 126980 || x === 127183 || x === 127374 || x >= 127377 && x <= 127386 || x >= 127488 && x <= 127490 || x >= 127504 && x <= 127547 || x >= 127552 && x <= 127560 || x === 127568 || x === 127569 || x >= 127584 && x <= 127589 || x >= 127744 && x <= 127776 || x >= 127789 && x <= 127797 || x >= 127799 && x <= 127868 || x >= 127870 && x <= 127891 || x >= 127904 && x <= 127946 || x >= 127951 && x <= 127955 || x >= 127968 && x <= 127984 || x === 127988 || x >= 127992 && x <= 128062 || x === 128064 || x >= 128066 && x <= 128252 || x >= 128255 && x <= 128317 || x >= 128331 && x <= 128334 || x >= 128336 && x <= 128359 || x === 128378 || x === 128405 || x === 128406 || x === 128420 || x >= 128507 && x <= 128591 || x >= 128640 && x <= 128709 || x === 128716 || x >= 128720 && x <= 128722 || x >= 128725 && x <= 128727 || x >= 128732 && x <= 128735 || x === 128747 || x === 128748 || x >= 128756 && x <= 128764 || x >= 128992 && x <= 129003 || x === 129008 || x >= 129292 && x <= 129338 || x >= 129340 && x <= 129349 || x >= 129351 && x <= 129535 || x >= 129648 && x <= 129660 || x >= 129664 && x <= 129673 || x >= 129679 && x <= 129734 || x >= 129742 && x <= 129756 || x >= 129759 && x <= 129769 || x >= 129776 && x <= 129784 || x >= 131072 && x <= 196605 || x >= 196608 && x <= 262141;
}

// node_modules/get-east-asian-width/index.js
function validate(codePoint) {
  if (!Number.isSafeInteger(codePoint)) {
    throw new TypeError(`Expected a code point, got \`${typeof codePoint}\`.`);
  }
}
function eastAsianWidth(codePoint, { ambiguousAsWide = false } = {}) {
  validate(codePoint);
  if (isFullWidth(codePoint) || isWide(codePoint) || ambiguousAsWide && isAmbiguous(codePoint)) {
    return 2;
  }
  return 1;
}

// node_modules/string-width/index.js
var import_emoji_regex = __toESM(require_emoji_regex(), 1);
var segmenter = new Intl.Segmenter;
var defaultIgnorableCodePointRegex = /^\p{Default_Ignorable_Code_Point}$/u;
function stringWidth(string2, options = {}) {
  if (typeof string2 !== "string" || string2.length === 0) {
    return 0;
  }
  const {
    ambiguousIsNarrow = true,
    countAnsiEscapeCodes = false
  } = options;
  if (!countAnsiEscapeCodes) {
    string2 = stripAnsi(string2);
  }
  if (string2.length === 0) {
    return 0;
  }
  let width = 0;
  const eastAsianWidthOptions = { ambiguousAsWide: !ambiguousIsNarrow };
  for (const { segment: character } of segmenter.segment(string2)) {
    const codePoint = character.codePointAt(0);
    if (codePoint <= 31 || codePoint >= 127 && codePoint <= 159) {
      continue;
    }
    if (codePoint >= 8203 && codePoint <= 8207 || codePoint === 65279) {
      continue;
    }
    if (codePoint >= 768 && codePoint <= 879 || codePoint >= 6832 && codePoint <= 6911 || codePoint >= 7616 && codePoint <= 7679 || codePoint >= 8400 && codePoint <= 8447 || codePoint >= 65056 && codePoint <= 65071) {
      continue;
    }
    if (codePoint >= 55296 && codePoint <= 57343) {
      continue;
    }
    if (codePoint >= 65024 && codePoint <= 65039) {
      continue;
    }
    if (defaultIgnorableCodePointRegex.test(character)) {
      continue;
    }
    if (import_emoji_regex.default().test(character)) {
      width += 2;
      continue;
    }
    width += eastAsianWidth(codePoint, eastAsianWidthOptions);
  }
  return width;
}

// node_modules/ansi-styles/index.js
var ANSI_BACKGROUND_OFFSET = 10;
var wrapAnsi16 = (offset = 0) => (code) => `\x1B[${code + offset}m`;
var wrapAnsi256 = (offset = 0) => (code) => `\x1B[${38 + offset};5;${code}m`;
var wrapAnsi16m = (offset = 0) => (red, green, blue) => `\x1B[${38 + offset};2;${red};${green};${blue}m`;
var styles = {
  modifier: {
    reset: [0, 0],
    bold: [1, 22],
    dim: [2, 22],
    italic: [3, 23],
    underline: [4, 24],
    overline: [53, 55],
    inverse: [7, 27],
    hidden: [8, 28],
    strikethrough: [9, 29]
  },
  color: {
    black: [30, 39],
    red: [31, 39],
    green: [32, 39],
    yellow: [33, 39],
    blue: [34, 39],
    magenta: [35, 39],
    cyan: [36, 39],
    white: [37, 39],
    blackBright: [90, 39],
    gray: [90, 39],
    grey: [90, 39],
    redBright: [91, 39],
    greenBright: [92, 39],
    yellowBright: [93, 39],
    blueBright: [94, 39],
    magentaBright: [95, 39],
    cyanBright: [96, 39],
    whiteBright: [97, 39]
  },
  bgColor: {
    bgBlack: [40, 49],
    bgRed: [41, 49],
    bgGreen: [42, 49],
    bgYellow: [43, 49],
    bgBlue: [44, 49],
    bgMagenta: [45, 49],
    bgCyan: [46, 49],
    bgWhite: [47, 49],
    bgBlackBright: [100, 49],
    bgGray: [100, 49],
    bgGrey: [100, 49],
    bgRedBright: [101, 49],
    bgGreenBright: [102, 49],
    bgYellowBright: [103, 49],
    bgBlueBright: [104, 49],
    bgMagentaBright: [105, 49],
    bgCyanBright: [106, 49],
    bgWhiteBright: [107, 49]
  }
};
var modifierNames = Object.keys(styles.modifier);
var foregroundColorNames = Object.keys(styles.color);
var backgroundColorNames = Object.keys(styles.bgColor);
var colorNames = [...foregroundColorNames, ...backgroundColorNames];
function assembleStyles() {
  const codes = new Map;
  for (const [groupName, group] of Object.entries(styles)) {
    for (const [styleName, style] of Object.entries(group)) {
      styles[styleName] = {
        open: `\x1B[${style[0]}m`,
        close: `\x1B[${style[1]}m`
      };
      group[styleName] = styles[styleName];
      codes.set(style[0], style[1]);
    }
    Object.defineProperty(styles, groupName, {
      value: group,
      enumerable: false
    });
  }
  Object.defineProperty(styles, "codes", {
    value: codes,
    enumerable: false
  });
  styles.color.close = "\x1B[39m";
  styles.bgColor.close = "\x1B[49m";
  styles.color.ansi = wrapAnsi16();
  styles.color.ansi256 = wrapAnsi256();
  styles.color.ansi16m = wrapAnsi16m();
  styles.bgColor.ansi = wrapAnsi16(ANSI_BACKGROUND_OFFSET);
  styles.bgColor.ansi256 = wrapAnsi256(ANSI_BACKGROUND_OFFSET);
  styles.bgColor.ansi16m = wrapAnsi16m(ANSI_BACKGROUND_OFFSET);
  Object.defineProperties(styles, {
    rgbToAnsi256: {
      value: (red, green, blue) => {
        if (red === green && green === blue) {
          if (red < 8) {
            return 16;
          }
          if (red > 248) {
            return 231;
          }
          return Math.round((red - 8) / 247 * 24) + 232;
        }
        return 16 + 36 * Math.round(red / 255 * 5) + 6 * Math.round(green / 255 * 5) + Math.round(blue / 255 * 5);
      },
      enumerable: false
    },
    hexToRgb: {
      value: (hex) => {
        const matches = /[a-f\d]{6}|[a-f\d]{3}/i.exec(hex.toString(16));
        if (!matches) {
          return [0, 0, 0];
        }
        let [colorString] = matches;
        if (colorString.length === 3) {
          colorString = [...colorString].map((character) => character + character).join("");
        }
        const integer = Number.parseInt(colorString, 16);
        return [
          integer >> 16 & 255,
          integer >> 8 & 255,
          integer & 255
        ];
      },
      enumerable: false
    },
    hexToAnsi256: {
      value: (hex) => styles.rgbToAnsi256(...styles.hexToRgb(hex)),
      enumerable: false
    },
    ansi256ToAnsi: {
      value: (code) => {
        if (code < 8) {
          return 30 + code;
        }
        if (code < 16) {
          return 90 + (code - 8);
        }
        let red;
        let green;
        let blue;
        if (code >= 232) {
          red = ((code - 232) * 10 + 8) / 255;
          green = red;
          blue = red;
        } else {
          code -= 16;
          const remainder = code % 36;
          red = Math.floor(code / 36) / 5;
          green = Math.floor(remainder / 6) / 5;
          blue = remainder % 6 / 5;
        }
        const value = Math.max(red, green, blue) * 2;
        if (value === 0) {
          return 30;
        }
        let result = 30 + (Math.round(blue) << 2 | Math.round(green) << 1 | Math.round(red));
        if (value === 2) {
          result += 60;
        }
        return result;
      },
      enumerable: false
    },
    rgbToAnsi: {
      value: (red, green, blue) => styles.ansi256ToAnsi(styles.rgbToAnsi256(red, green, blue)),
      enumerable: false
    },
    hexToAnsi: {
      value: (hex) => styles.ansi256ToAnsi(styles.hexToAnsi256(hex)),
      enumerable: false
    }
  });
  return styles;
}
var ansiStyles = assembleStyles();
var ansi_styles_default = ansiStyles;

// node_modules/wrap-ansi/index.js
var ESCAPES = new Set([
  "\x1B",
  ""
]);
var END_CODE = 39;
var ANSI_ESCAPE_BELL = "\x07";
var ANSI_CSI = "[";
var ANSI_OSC = "]";
var ANSI_SGR_TERMINATOR = "m";
var ANSI_ESCAPE_LINK = `${ANSI_OSC}8;;`;
var wrapAnsiCode = (code) => `${ESCAPES.values().next().value}${ANSI_CSI}${code}${ANSI_SGR_TERMINATOR}`;
var wrapAnsiHyperlink = (url) => `${ESCAPES.values().next().value}${ANSI_ESCAPE_LINK}${url}${ANSI_ESCAPE_BELL}`;
var wordLengths = (string2) => string2.split(" ").map((character) => stringWidth(character));
var wrapWord = (rows, word, columns) => {
  const characters = [...word];
  let isInsideEscape = false;
  let isInsideLinkEscape = false;
  let visible = stringWidth(stripAnsi(rows.at(-1)));
  for (const [index, character] of characters.entries()) {
    const characterLength = stringWidth(character);
    if (visible + characterLength <= columns) {
      rows[rows.length - 1] += character;
    } else {
      rows.push(character);
      visible = 0;
    }
    if (ESCAPES.has(character)) {
      isInsideEscape = true;
      const ansiEscapeLinkCandidate = characters.slice(index + 1, index + 1 + ANSI_ESCAPE_LINK.length).join("");
      isInsideLinkEscape = ansiEscapeLinkCandidate === ANSI_ESCAPE_LINK;
    }
    if (isInsideEscape) {
      if (isInsideLinkEscape) {
        if (character === ANSI_ESCAPE_BELL) {
          isInsideEscape = false;
          isInsideLinkEscape = false;
        }
      } else if (character === ANSI_SGR_TERMINATOR) {
        isInsideEscape = false;
      }
      continue;
    }
    visible += characterLength;
    if (visible === columns && index < characters.length - 1) {
      rows.push("");
      visible = 0;
    }
  }
  if (!visible && rows.at(-1).length > 0 && rows.length > 1) {
    rows[rows.length - 2] += rows.pop();
  }
};
var stringVisibleTrimSpacesRight = (string2) => {
  const words = string2.split(" ");
  let last = words.length;
  while (last > 0) {
    if (stringWidth(words[last - 1]) > 0) {
      break;
    }
    last--;
  }
  if (last === words.length) {
    return string2;
  }
  return words.slice(0, last).join(" ") + words.slice(last).join("");
};
var exec = (string2, columns, options = {}) => {
  if (options.trim !== false && string2.trim() === "") {
    return "";
  }
  let returnValue = "";
  let escapeCode;
  let escapeUrl;
  const lengths = wordLengths(string2);
  let rows = [""];
  for (const [index, word] of string2.split(" ").entries()) {
    if (options.trim !== false) {
      rows[rows.length - 1] = rows.at(-1).trimStart();
    }
    let rowLength = stringWidth(rows.at(-1));
    if (index !== 0) {
      if (rowLength >= columns && (options.wordWrap === false || options.trim === false)) {
        rows.push("");
        rowLength = 0;
      }
      if (rowLength > 0 || options.trim === false) {
        rows[rows.length - 1] += " ";
        rowLength++;
      }
    }
    if (options.hard && lengths[index] > columns) {
      const remainingColumns = columns - rowLength;
      const breaksStartingThisLine = 1 + Math.floor((lengths[index] - remainingColumns - 1) / columns);
      const breaksStartingNextLine = Math.floor((lengths[index] - 1) / columns);
      if (breaksStartingNextLine < breaksStartingThisLine) {
        rows.push("");
      }
      wrapWord(rows, word, columns);
      continue;
    }
    if (rowLength + lengths[index] > columns && rowLength > 0 && lengths[index] > 0) {
      if (options.wordWrap === false && rowLength < columns) {
        wrapWord(rows, word, columns);
        continue;
      }
      rows.push("");
    }
    if (rowLength + lengths[index] > columns && options.wordWrap === false) {
      wrapWord(rows, word, columns);
      continue;
    }
    rows[rows.length - 1] += word;
  }
  if (options.trim !== false) {
    rows = rows.map((row) => stringVisibleTrimSpacesRight(row));
  }
  const preString = rows.join(`
`);
  const pre = [...preString];
  let preStringIndex = 0;
  for (const [index, character] of pre.entries()) {
    returnValue += character;
    if (ESCAPES.has(character)) {
      const { groups } = new RegExp(`(?:\\${ANSI_CSI}(?<code>\\d+)m|\\${ANSI_ESCAPE_LINK}(?<uri>.*)${ANSI_ESCAPE_BELL})`).exec(preString.slice(preStringIndex)) || { groups: {} };
      if (groups.code !== undefined) {
        const code2 = Number.parseFloat(groups.code);
        escapeCode = code2 === END_CODE ? undefined : code2;
      } else if (groups.uri !== undefined) {
        escapeUrl = groups.uri.length === 0 ? undefined : groups.uri;
      }
    }
    const code = ansi_styles_default.codes.get(Number(escapeCode));
    if (pre[index + 1] === `
`) {
      if (escapeUrl) {
        returnValue += wrapAnsiHyperlink("");
      }
      if (escapeCode && code) {
        returnValue += wrapAnsiCode(code);
      }
    } else if (character === `
`) {
      if (escapeCode && code) {
        returnValue += wrapAnsiCode(escapeCode);
      }
      if (escapeUrl) {
        returnValue += wrapAnsiHyperlink(escapeUrl);
      }
    }
    preStringIndex += character.length;
  }
  return returnValue;
};
function wrapAnsi(string2, columns, options) {
  return String(string2).normalize().replaceAll(`\r
`, `
`).split(`
`).map((line) => exec(line, columns, options)).join(`
`);
}

// src/core/prompts/prompt.ts
class Prompt {
  input;
  output;
  _abortSignal;
  rl;
  opts;
  _render;
  _track = false;
  _prevFrame = "";
  _subscribers = new Map;
  _cursor = 0;
  _manualLine = "";
  state = "initial";
  error = "";
  value;
  userInput = "";
  constructor(options, trackValue = true) {
    const { input = stdin2, output = stdout2, render, signal, ...opts } = options;
    this.opts = opts;
    this.onKeypress = this.onKeypress.bind(this);
    this.close = this.close.bind(this);
    this.render = this.render.bind(this);
    this._render = render.bind(this);
    this._track = trackValue;
    this._abortSignal = signal;
    this.input = input;
    this.output = output;
  }
  unsubscribe() {
    this._subscribers.clear();
  }
  setSubscriber(event, opts) {
    const params = this._subscribers.get(event) ?? [];
    params.push(opts);
    this._subscribers.set(event, params);
  }
  on(event, cb) {
    this.setSubscriber(event, { cb });
    return this;
  }
  once(event, cb) {
    this.setSubscriber(event, { cb, once: true });
    return this;
  }
  emit(event, ...data) {
    const cbs = this._subscribers.get(event) ?? [];
    const cleanup = [];
    for (const subscriber of cbs) {
      subscriber.cb(...data);
      if (subscriber.once) {
        cleanup.push(() => cbs.splice(cbs.indexOf(subscriber), 1));
      }
    }
    for (const cb of cleanup) {
      cb();
    }
    return this;
  }
  prompt() {
    return new Promise((resolve) => {
      if (this._abortSignal) {
        if (this._abortSignal.aborted) {
          this.state = "cancel";
          this.close();
          return resolve(CANCEL_SYMBOL);
        }
        this._abortSignal.addEventListener("abort", () => {
          this.state = "cancel";
          this.close();
        }, { once: true });
      }
      this.rl = readline2.createInterface({
        input: this.input,
        tabSize: 2,
        prompt: "",
        escapeCodeTimeout: 50,
        terminal: true
      });
      this.rl.prompt();
      if (this.opts.initialUserInput !== undefined) {
        this._setUserInput(this.opts.initialUserInput, true);
      }
      this.input.on("keypress", this.onKeypress);
      setRawMode(this.input, true);
      this.output.on("resize", this.render);
      this.render();
      this.once("submit", () => {
        this.output.write(cursor.show);
        this.output.off("resize", this.render);
        setRawMode(this.input, false);
        resolve(this.value);
      });
      this.once("cancel", () => {
        this.output.write(cursor.show);
        this.output.off("resize", this.render);
        setRawMode(this.input, false);
        resolve(CANCEL_SYMBOL);
      });
    });
  }
  _isActionKey(char, _key) {
    return char === "\t";
  }
  _setValue(value) {
    this.value = value;
    this.emit("value", this.value);
  }
  _setUserInput(value, write) {
    this.userInput = value ?? "";
    this.emit("userInput", this.userInput);
    if (write && this._track && this.rl) {
      this.rl.write(this.userInput);
      this._cursor = this.rl.cursor;
    }
  }
  onKeypress(char, key) {
    if (this._track && key.name !== "return") {
      if (key.name && this._isActionKey(char, key)) {
        this.rl?.write(null, { ctrl: true, name: "h" });
      }
      this._cursor = this.rl?.cursor ?? 0;
      const isSpecialKey = key.name === "tab" || key.name === "escape" || key.name === "backspace" || key.name === "delete" || key.name === "enter" || key.name === "return" || key.name && ["up", "down", "left", "right"].includes(key.name);
      if (char && !isSpecialKey && char.length === 1 && char >= " ") {
        this._manualLine += char;
      } else if (key.name === "backspace" && this._manualLine.length > 0) {
        this._manualLine = this._manualLine.slice(0, -1);
      }
      const effectiveLine = this._manualLine.length >= (this.rl?.line?.length || 0) ? this._manualLine : this.rl?.line;
      this._setUserInput(effectiveLine);
    }
    if (this.state === "error") {
      this.state = "active";
      this.error = "";
    }
    if (key?.name) {
      if (!this._track && settings.aliases.has(key.name)) {
        this.emit("cursor", settings.aliases.get(key.name));
      }
      if (settings.actions.has(key.name)) {
        this.emit("cursor", key.name);
      }
    }
    if (char && (char.toLowerCase() === "y" || char.toLowerCase() === "n")) {
      this.emit("confirm", char.toLowerCase() === "y");
    }
    this.emit("key", char?.toLowerCase(), key);
    if (key?.name === "return") {
      if (this.opts.validate) {
        const problem = this.opts.validate(this.value);
        if (problem) {
          this.error = problem instanceof Error ? problem.message : problem;
          this.state = "error";
        }
      }
      if (this.state !== "error") {
        this.state = "submit";
      }
    }
    if (isActionKey([char, key?.name, key?.sequence], "cancel")) {
      this.state = "cancel";
    }
    if (this.state === "submit" || this.state === "cancel") {
      this.emit("finalize");
    }
    this.render();
    if (this.state === "submit" || this.state === "cancel") {
      this.close();
    }
  }
  close() {
    this.input.unpipe();
    this.input.removeListener("keypress", this.onKeypress);
    this.output.write(`
`);
    setRawMode(this.input, false);
    this.rl?.close();
    this.rl = undefined;
    this.emit(`${this.state}`, this.value);
    if (this.state === "cancel") {
      setTimeout(() => {
        this.unsubscribe();
      }, 10);
    } else {
      this.unsubscribe();
    }
  }
  restoreCursor() {
    const lines = wrapAnsi(this._prevFrame, process6.stdout.columns, { hard: true, trim: false }).split(`
`).length - 1;
    this.output.write(cursor.move(-999, lines * -1));
  }
  render() {
    const frame = wrapAnsi(this._render(this) ?? "", process6.stdout.columns, {
      hard: true,
      trim: false
    });
    if (frame === this._prevFrame) {
      return;
    }
    if (this.state === "initial") {
      this.output.write(cursor.hide);
    } else {
      const diff = diffLines(this._prevFrame, frame);
      this.restoreCursor();
      if (diff && diff?.length === 1) {
        const diffLine = diff[0];
        this.output.write(cursor.move(0, diffLine));
        this.output.write(erase.lines(1));
        const lines = frame.split(`
`);
        this.output.write(lines[diffLine]);
        this._prevFrame = frame;
        this.output.write(cursor.move(0, lines.length - diffLine - 1));
        return;
      }
      if (diff && diff?.length > 1) {
        const diffLine = diff[0];
        this.output.write(cursor.move(0, diffLine));
        this.output.write(erase.down());
        const lines = frame.split(`
`);
        const newLines = lines.slice(diffLine);
        this.output.write(newLines.join(`
`));
        this._prevFrame = frame;
        return;
      }
      this.output.write(erase.down());
    }
    this.output.write(frame);
    if (this.state === "initial") {
      this.state = "active";
    }
    this._prevFrame = frame;
  }
}

// src/core/prompts/autocomplete.ts
function getCursorForValue(selected, items) {
  if (selected === undefined) {
    return 0;
  }
  const currLength = items.length;
  if (currLength === 0) {
    return 0;
  }
  const index = items.findIndex((item) => item.value === selected);
  return index !== -1 ? index : 0;
}
function defaultFilter(input, option) {
  const label = option.label ?? String(option.value);
  return label.toLowerCase().includes(input.toLowerCase());
}
function normalisedValue(multiple, values) {
  if (!values) {
    return;
  }
  if (multiple) {
    return values;
  }
  return values[0];
}

class AutocompletePrompt extends Prompt {
  filteredOptions;
  multiple;
  isNavigating = false;
  selectedValues = [];
  focusedValue;
  #cursor = 0;
  #lastUserInput = "";
  #filterFn;
  #options;
  get cursor() {
    return this.#cursor;
  }
  get userInputWithCursor() {
    if (!this.userInput) {
      return import_picocolors.default.inverse(import_picocolors.default.hidden("_"));
    }
    if (this._cursor >= this.userInput.length) {
      return `${this.userInput}█`;
    }
    const s1 = this.userInput.slice(0, this._cursor);
    const [s2, ...s3] = this.userInput.slice(this._cursor);
    return `${s1}${import_picocolors.default.inverse(s2)}${s3.join("")}`;
  }
  get options() {
    if (typeof this.#options === "function") {
      return this.#options();
    }
    return this.#options;
  }
  constructor(opts) {
    super(opts);
    this.#options = opts.options;
    const options = this.options;
    this.filteredOptions = [...options];
    this.multiple = opts.multiple === true;
    this.#filterFn = opts.filter ?? defaultFilter;
    let initialValues;
    if (opts.initialValue && Array.isArray(opts.initialValue)) {
      if (this.multiple) {
        initialValues = opts.initialValue;
      } else {
        initialValues = opts.initialValue.slice(0, 1);
      }
    } else {
      if (!this.multiple && this.options.length > 0) {
        initialValues = [this.options[0].value];
      }
    }
    if (initialValues) {
      for (const selectedValue of initialValues) {
        const selectedIndex = options.findIndex((opt) => opt.value === selectedValue);
        if (selectedIndex !== -1) {
          this.toggleSelected(selectedValue);
          this.#cursor = selectedIndex;
        }
      }
    }
    this.focusedValue = this.options[this.#cursor]?.value;
    this.on("key", (char, key) => this.#onKey(char, key));
    this.on("userInput", (value) => this.#onUserInputChanged(value));
  }
  _isActionKey(char, key) {
    return char === "\t" || this.multiple && this.isNavigating && key.name === "space" && char !== undefined && char !== "";
  }
  #onKey(_char, key) {
    const isUpKey = key.name === "up";
    const isDownKey = key.name === "down";
    const isReturnKey = key.name === "return";
    if (isUpKey || isDownKey) {
      this.#cursor = Math.max(0, Math.min(this.#cursor + (isUpKey ? -1 : 1), this.filteredOptions.length - 1));
      this.focusedValue = this.filteredOptions[this.#cursor]?.value;
      if (!this.multiple) {
        this.selectedValues = [this.focusedValue];
      }
      this.isNavigating = true;
    } else if (isReturnKey) {
      this.value = normalisedValue(this.multiple, this.selectedValues);
    } else {
      if (this.multiple) {
        if (this.focusedValue !== undefined && (key.name === "tab" || this.isNavigating && key.name === "space")) {
          this.toggleSelected(this.focusedValue);
        } else {
          this.isNavigating = false;
        }
      } else {
        if (this.focusedValue) {
          this.selectedValues = [this.focusedValue];
        }
        this.isNavigating = false;
      }
    }
  }
  deselectAll() {
    this.selectedValues = [];
  }
  toggleSelected(value) {
    if (this.filteredOptions.length === 0) {
      return;
    }
    if (this.multiple) {
      if (this.selectedValues.includes(value)) {
        this.selectedValues = this.selectedValues.filter((v) => v !== value);
      } else {
        this.selectedValues = [...this.selectedValues, value];
      }
    } else {
      this.selectedValues = [value];
    }
  }
  #onUserInputChanged(value) {
    if (value !== this.#lastUserInput) {
      this.#lastUserInput = value;
      const options = this.options;
      if (value) {
        this.filteredOptions = options.filter((opt) => this.#filterFn(value, opt));
      } else {
        this.filteredOptions = [...options];
      }
      this.#cursor = getCursorForValue(this.focusedValue, this.filteredOptions);
      this.focusedValue = this.filteredOptions[this.#cursor]?.value;
      if (!this.multiple) {
        if (this.focusedValue !== undefined) {
          this.toggleSelected(this.focusedValue);
        } else {
          this.deselectAll();
        }
      }
    }
  }
}
// src/core/prompts/confirm.ts
class ConfirmPrompt extends Prompt {
  get cursor() {
    return this.value ? 0 : 1;
  }
  get _value() {
    return this.cursor === 0;
  }
  constructor(opts) {
    super(opts, false);
    this.value = !!opts.initialValue;
    this.on("userInput", () => {
      this.value = this._value;
    });
    this.on("confirm", (confirm) => {
      this.output.write(cursor.move(0, -1));
      this.value = confirm;
      this.state = "submit";
      this.close();
    });
    this.on("cursor", () => {
      this.value = !this.value;
    });
  }
}
// src/core/prompts/group-multiselect.ts
class GroupMultiSelectPrompt extends Prompt {
  options;
  cursor = 0;
  #selectableGroups;
  getGroupItems(group) {
    return this.options.filter((o) => o.group === group);
  }
  isGroupSelected(group) {
    const items = this.getGroupItems(group);
    const value = this.value;
    if (value === undefined) {
      return false;
    }
    return items.every((i) => value.includes(i.value));
  }
  toggleValue() {
    const item = this.options[this.cursor];
    if (this.value === undefined) {
      this.value = [];
    }
    if (item.group === true) {
      const group = item.value;
      const groupedItems = this.getGroupItems(group);
      if (this.isGroupSelected(group)) {
        this.value = this.value.filter((v) => groupedItems.findIndex((i) => i.value === v) === -1);
      } else {
        this.value = [...this.value, ...groupedItems.map((i) => i.value)];
      }
      this.value = Array.from(new Set(this.value));
    } else {
      const selected = this.value.includes(item.value);
      this.value = selected ? this.value.filter((v) => v !== item.value) : [...this.value, item.value];
    }
  }
  constructor(opts) {
    super(opts, false);
    const { options } = opts;
    this.#selectableGroups = opts.selectableGroups !== false;
    this.options = Object.entries(options).flatMap(([key, option]) => [
      { value: key, group: true, label: key },
      ...option.map((opt) => ({ ...opt, group: key }))
    ]);
    this.value = [...opts.initialValues ?? []];
    this.cursor = Math.max(this.options.findIndex(({ value }) => value === opts.cursorAt), this.#selectableGroups ? 0 : 1);
    this.on("cursor", (key) => {
      switch (key) {
        case "left":
        case "up": {
          this.cursor = this.cursor === 0 ? this.options.length - 1 : this.cursor - 1;
          const currentIsGroup = this.options[this.cursor]?.group === true;
          if (!this.#selectableGroups && currentIsGroup) {
            this.cursor = this.cursor === 0 ? this.options.length - 1 : this.cursor - 1;
          }
          break;
        }
        case "down":
        case "right": {
          this.cursor = this.cursor === this.options.length - 1 ? 0 : this.cursor + 1;
          const currentIsGroup = this.options[this.cursor]?.group === true;
          if (!this.#selectableGroups && currentIsGroup) {
            this.cursor = this.cursor === this.options.length - 1 ? 0 : this.cursor + 1;
          }
          break;
        }
        case "space":
          this.toggleValue();
          break;
      }
    });
  }
}
// src/core/prompts/multi-select.ts
class MultiSelectPrompt extends Prompt {
  options;
  cursor = 0;
  get _value() {
    return this.options[this.cursor].value;
  }
  toggleAll() {
    const allSelected = this.value !== undefined && this.value.length === this.options.length;
    this.value = allSelected ? [] : this.options.map((v) => v.value);
  }
  toggleValue() {
    if (this.value === undefined) {
      this.value = [];
    }
    const selected = this.value.includes(this._value);
    this.value = selected ? this.value.filter((value) => value !== this._value) : [...this.value, this._value];
  }
  constructor(opts) {
    super(opts, false);
    this.options = opts.options;
    this.value = [...opts.initialValues ?? []];
    this.cursor = Math.max(this.options.findIndex(({ value }) => value === opts.cursorAt), 0);
    this.on("key", (char) => {
      if (char === "a") {
        this.toggleAll();
      }
    });
    this.on("cursor", (key) => {
      switch (key) {
        case "left":
        case "up":
          this.cursor = this.cursor === 0 ? this.options.length - 1 : this.cursor - 1;
          break;
        case "down":
        case "right":
          this.cursor = this.cursor === this.options.length - 1 ? 0 : this.cursor + 1;
          break;
        case "space":
          this.toggleValue();
          break;
      }
    });
  }
}
// src/core/prompts/password.ts
var import_picocolors2 = __toESM(require_picocolors(), 1);
class PasswordPrompt extends Prompt {
  _mask = "•";
  get cursor() {
    return this._cursor;
  }
  get masked() {
    return this.userInput.replaceAll(/./g, this._mask);
  }
  get userInputWithCursor() {
    if (this.state === "submit" || this.state === "cancel") {
      return this.masked;
    }
    const userInput = this.userInput;
    if (this.cursor >= userInput.length) {
      return `${this.masked}${import_picocolors2.default.inverse(import_picocolors2.default.hidden("_"))}`;
    }
    const masked = this.masked;
    const s1 = masked.slice(0, this.cursor);
    const s2 = masked.slice(this.cursor);
    return `${s1}${import_picocolors2.default.inverse(s2[0])}${s2.slice(1)}`;
  }
  constructor({ mask, ...opts }) {
    super(opts);
    this._mask = mask ?? "•";
    this.on("userInput", (input) => {
      this._setValue(input);
    });
  }
}
// src/core/prompts/select.ts
class SelectPrompt extends Prompt {
  options;
  cursor = 0;
  get _selectedValue() {
    return this.options[this.cursor];
  }
  changeValue() {
    this.value = this._selectedValue.value;
  }
  constructor(opts) {
    super(opts, false);
    this.options = opts.options;
    this.cursor = this.options.findIndex(({ value }) => value === opts.initialValue);
    if (this.cursor === -1)
      this.cursor = 0;
    this.changeValue();
    this.on("cursor", (key) => {
      switch (key) {
        case "left":
        case "up":
          this.cursor = this.cursor === 0 ? this.options.length - 1 : this.cursor - 1;
          break;
        case "down":
        case "right":
          this.cursor = this.cursor === this.options.length - 1 ? 0 : this.cursor + 1;
          break;
      }
      this.changeValue();
    });
  }
}
// src/core/prompts/select-key.ts
class SelectKeyPrompt extends Prompt {
  options;
  cursor = 0;
  constructor(opts) {
    super(opts, false);
    this.options = opts.options;
    const keys = this.options.map(({ value: [initial] }) => initial?.toLowerCase());
    this.cursor = Math.max(keys.indexOf(opts.initialValue), 0);
    this.on("key", (key) => {
      if (!key || !keys.includes(key))
        return;
      const value = this.options.find(({ value: [initial] }) => initial?.toLowerCase() === key);
      if (value) {
        this.value = value.value;
        this.state = "submit";
        this.emit("submit");
      }
    });
  }
}
// src/core/prompts/text.ts
var import_picocolors3 = __toESM(require_picocolors(), 1);
class TextPrompt extends Prompt {
  placeholder;
  get userInputWithCursor() {
    if (this.state === "submit") {
      return this.userInput;
    }
    const userInput = this.userInput;
    if (this.cursor >= userInput.length) {
      return `${this.userInput}█`;
    }
    const s1 = userInput.slice(0, this.cursor);
    const [s2, ...s3] = userInput.slice(this.cursor);
    return `${s1}${import_picocolors3.default.inverse(s2)}${s3.join("")}`;
  }
  get cursor() {
    return this._cursor;
  }
  constructor(opts) {
    super({ ...opts, initialUserInput: opts.initialUserInput ?? opts.initialValue });
    this.placeholder = opts.placeholder;
    this.on("key", (char) => {
      if (char === "\t" && this.placeholder) {
        if (!this.value) {
          this._setValue(this.placeholder);
          this._setUserInput(this.placeholder, true);
        }
      }
    });
    this.on("userInput", (input) => {
      this._setValue(input);
    });
    this.on("finalize", () => {
      if (!this.userInput && this.placeholder) {
        this.value = this.placeholder;
      }
      if (!this.value) {
        this.value = opts.defaultValue;
      }
      if (this.value === undefined) {
        this.value = "";
      }
    });
  }
}
// src/prompts/common.ts
var import_picocolors4 = __toESM(require_picocolors(), 1);
import process7 from "node:process";

// src/style.ts
var codes = {
  red: ["\x1B[31m", "\x1B[39m"],
  green: ["\x1B[32m", "\x1B[39m"],
  blue: ["\x1B[34m", "\x1B[39m"],
  yellow: ["\x1B[33m", "\x1B[39m"],
  cyan: ["\x1B[36m", "\x1B[39m"],
  magenta: ["\x1B[35m", "\x1B[39m"],
  white: ["\x1B[37m", "\x1B[39m"],
  gray: ["\x1B[90m", "\x1B[39m"],
  bgRed: ["\x1B[41m", "\x1B[49m"],
  bgGreen: ["\x1B[42m", "\x1B[49m"],
  bgBlue: ["\x1B[44m", "\x1B[49m"],
  bgYellow: ["\x1B[43m", "\x1B[49m"],
  bgCyan: ["\x1B[46m", "\x1B[49m"],
  bgMagenta: ["\x1B[45m", "\x1B[49m"],
  bold: ["\x1B[1m", "\x1B[22m"],
  italic: ["\x1B[3m", "\x1B[23m"],
  underline: ["\x1B[4m", "\x1B[24m"],
  dim: ["\x1B[2m", "\x1B[22m"],
  inverse: ["\x1B[7m", "\x1B[27m"],
  hidden: ["\x1B[8m", "\x1B[28m"],
  strikethrough: ["\x1B[9m", "\x1B[29m"]
};
var theme = {
  primary: "blue",
  secondary: "cyan",
  success: "green",
  warning: "yellow",
  error: "red",
  info: "magenta",
  muted: "gray"
};
function detectColorSupport() {
  return true;
}
function createStyler() {
  const styler = {};
  styler.supportsColor = detectColorSupport();
  function createStyleFunction(styleName, styles2 = []) {
    const styleList = styleName === "" ? [] : [...styles2, styleName];
    const fn = function(text) {
      if (!styler.supportsColor)
        return text;
      let openCodes = "";
      let closeCodes = "";
      for (const style of styleList) {
        if (style in theme && theme[style] in codes) {
          const themeStyle = theme[style];
          openCodes += codes[themeStyle][0];
          closeCodes = codes[themeStyle][1] + closeCodes;
        } else if (style in codes) {
          openCodes += codes[style][0];
          closeCodes = codes[style][1] + closeCodes;
        }
      }
      return openCodes + text + closeCodes;
    };
    const allStyles2 = [...Object.keys(codes), ...Object.keys(theme)];
    for (const style of allStyles2) {
      if (!(style in fn)) {
        Object.defineProperty(fn, style, {
          get() {
            return createStyleFunction(style, styleList);
          }
        });
      }
    }
    return fn;
  }
  const allStyles = [...Object.keys(codes), ...Object.keys(theme)];
  for (const style of allStyles) {
    if (!(style in styler)) {
      Object.defineProperty(styler, style, {
        get() {
          return createStyleFunction(style);
        }
      });
    }
  }
  return styler;
}
var style = createStyler();
function setTheme(customTheme) {
  for (const key in customTheme) {
    if (customTheme[key] !== undefined) {
      theme[key] = customTheme[key];
    }
  }
}
function setAccessibility(options) {
  if (options.colors !== undefined) {
    style.supportsColor = options.colors;
  }
}
function box(content, options) {
  const title = options?.title ? ` ${options.title} ` : "";
  const padding = options?.padding || 0;
  const paddingStr = " ".repeat(padding);
  const lines = content.split(`
`);
  const contentWidth = Math.max(...lines.map((line) => line.length));
  const innerWidth = contentWidth + padding * 2;
  const totalWidth = innerWidth;
  console.log(`┌${title ? "─".repeat(Math.floor((totalWidth - title.length) / 2)) + title + "─".repeat(Math.ceil((totalWidth - title.length) / 2)) : "─".repeat(totalWidth)}┐`);
  console.log(`│${" ".repeat(totalWidth)}│`);
  for (const line of lines) {
    const rightPadding = innerWidth - line.length - padding;
    console.log(`│${paddingStr}${line}${" ".repeat(rightPadding)}│`);
  }
  console.log(`│${" ".repeat(totalWidth)}│`);
  console.log(`└${"─".repeat(totalWidth)}┘`);
}
function panel(options) {
  const title = options?.title ? ` ${options.title} ` : "";
  const content = options.content;
  const lines = content.split(`
`);
  const contentWidth = Math.max(...lines.map((line) => line.length));
  const innerWidth = contentWidth + 2;
  console.log(`╔${title ? "═".repeat(Math.floor((innerWidth - title.length) / 2)) + title + "═".repeat(Math.ceil((innerWidth - title.length) / 2)) : "═".repeat(innerWidth)}╗`);
  console.log(`║${" ".repeat(innerWidth)}║`);
  for (const line of lines) {
    const rightPadding = innerWidth - line.length - 1;
    console.log(`║ ${line}${" ".repeat(rightPadding)}║`);
  }
  console.log(`║${" ".repeat(innerWidth)}║`);
  console.log(`╚${"═".repeat(innerWidth)}╝`);
}
function table(data, options) {
  if (!data || data.length === 0)
    return;
  const colWidths = Array.from({ length: data[0].length }, () => 0);
  for (const row of data) {
    for (let i = 0;i < row.length; i++) {
      colWidths[i] = Math.max(colWidths[i], String(row[i]).length);
    }
  }
  if (options?.border) {
    console.log(`┌${colWidths.map((w) => "─".repeat(w + 2)).join("┬")}┐`);
  }
  if (options?.header && data.length > 0) {
    console.log((options.border ? "│ " : "") + data[0].map((cell, i) => `${cell}${" ".repeat(colWidths[i] - String(cell).length)}`).join(" │ ") + (options.border ? " │" : ""));
    if (options.border) {
      console.log(`├${colWidths.map((w) => "─".repeat(w + 2)).join("┼")}┤`);
    } else {
      console.log(`${colWidths.map((w) => "─".repeat(w)).join("─┼─")}`);
    }
  }
  const startRow = options?.header ? 1 : 0;
  for (let r = startRow;r < data.length; r++) {
    console.log((options?.border ? "│ " : "") + data[r].map((cell, i) => `${cell}${" ".repeat(colWidths[i] - String(cell).length)}`).join(" │ ") + (options?.border ? " │" : ""));
  }
  if (options?.border) {
    console.log(`└${colWidths.map((w) => "─".repeat(w + 2)).join("┴")}┘`);
  }
}

// src/prompts/common.ts
var unicode = isUnicodeSupported();
var isCI = () => process7.env.CI === "true";
function isTTY(output) {
  return output.isTTY === true;
}
var unicodeOr = (c, fallback) => unicode ? c : fallback;
var S_STEP_ACTIVE = unicodeOr("◆", "*");
var S_STEP_CANCEL = unicodeOr("■", "x");
var S_STEP_ERROR = unicodeOr("▲", "x");
var S_STEP_SUBMIT = unicodeOr("◇", "o");
var S_BAR_START = unicodeOr("┌", "T");
var S_BAR = unicodeOr("│", "|");
var S_BAR_END = unicodeOr("└", "—");
var S_RADIO_ACTIVE = unicodeOr("●", ">");
var S_RADIO_INACTIVE = unicodeOr("○", " ");
var S_CHECKBOX_ACTIVE = unicodeOr("◻", "[•]");
var S_CHECKBOX_SELECTED = unicodeOr("◼", "[+]");
var S_CHECKBOX_INACTIVE = unicodeOr("◻", "[ ]");
var S_PASSWORD_MASK = unicodeOr("▪", "•");
var S_BAR_H = unicodeOr("─", "-");
var S_CORNER_TOP_RIGHT = unicodeOr("╮", "+");
var S_CONNECT_LEFT = unicodeOr("├", "+");
var S_CORNER_BOTTOM_RIGHT = unicodeOr("╯", "+");
var S_INFO = unicodeOr("●", "•");
var S_SUCCESS = unicodeOr("◆", "*");
var S_WARN = unicodeOr("▲", "!");
var S_ERROR = unicodeOr("■", "x");
function symbol(state) {
  switch (state) {
    case "initial":
    case "active":
      return import_picocolors4.default.cyan(S_STEP_ACTIVE);
    case "cancel":
      return import_picocolors4.default.red(S_STEP_CANCEL);
    case "error":
      return import_picocolors4.default.yellow(S_STEP_ERROR);
    case "submit":
      return import_picocolors4.default.green(S_STEP_SUBMIT);
  }
}
function processMarkdown(text) {
  return text.replace(/_([^_]+)_/g, (_, content) => style.italic(content));
}

// src/prompts/limit-options.ts
var import_picocolors5 = __toESM(require_picocolors(), 1);
import process8 from "node:process";
import { WriteStream as WriteStream2 } from "node:tty";
function limitOptions(params) {
  const { cursor: cursor2, options, style: style2 } = params;
  const output = params.output ?? process8.stdout;
  const rows = output instanceof WriteStream2 && output.rows !== undefined ? output.rows : 10;
  const overflowFormat = import_picocolors5.default.dim("...");
  const paramMaxItems = params.maxItems ?? Number.POSITIVE_INFINITY;
  const outputMaxItems = Math.max(rows - 4, 0);
  const maxItems = Math.min(outputMaxItems, Math.max(paramMaxItems, 5));
  let slidingWindowLocation = 0;
  if (cursor2 >= slidingWindowLocation + maxItems - 3) {
    slidingWindowLocation = Math.max(Math.min(cursor2 - maxItems + 3, options.length - maxItems), 0);
  } else if (cursor2 < slidingWindowLocation + 2) {
    slidingWindowLocation = Math.max(cursor2 - 2, 0);
  }
  const shouldRenderTopEllipsis = maxItems < options.length && slidingWindowLocation > 0;
  const shouldRenderBottomEllipsis = maxItems < options.length && slidingWindowLocation + maxItems < options.length;
  return options.slice(slidingWindowLocation, slidingWindowLocation + maxItems).map((option, i, arr) => {
    const isTopLimit = i === 0 && shouldRenderTopEllipsis;
    const isBottomLimit = i === arr.length - 1 && shouldRenderBottomEllipsis;
    return isTopLimit || isBottomLimit ? overflowFormat : style2(option, i + slidingWindowLocation === cursor2);
  });
}

// src/prompts/autocomplete.ts
function getLabel(option) {
  return option.label ?? String(option.value ?? "");
}
function getFilteredOption(searchText, option) {
  if (!searchText) {
    return true;
  }
  const label = (option.label ?? String(option.value ?? "")).toLowerCase();
  const hint = (option.hint ?? "").toLowerCase();
  const value = String(option.value).toLowerCase();
  const term = searchText.toLowerCase();
  return label.includes(term) || hint.includes(term) || value.includes(term);
}
function getSelectedOptions(values, options) {
  const results = [];
  for (const option of options) {
    if (values.includes(option.value)) {
      results.push(option);
    }
  }
  return results;
}
function autocomplete(opts) {
  const prompt = new AutocompletePrompt({
    options: opts.options,
    initialValue: opts.initialValue ? [opts.initialValue] : undefined,
    initialUserInput: opts.initialUserInput,
    filter: (search, opt) => {
      return getFilteredOption(search, opt);
    },
    signal: opts.signal,
    input: opts.input,
    output: opts.output,
    validate: opts.validate,
    render() {
      const title = `${import_picocolors6.default.gray(S_BAR)}
${symbol(this.state)}  ${opts.message}
`;
      const userInput = this.userInput;
      const valueAsString = String(this.value ?? "");
      const options = this.options;
      const placeholder = opts.placeholder;
      const showPlaceholder = valueAsString === "" && placeholder !== undefined;
      switch (this.state) {
        case "submit": {
          const selected = getSelectedOptions(this.selectedValues, options);
          const label = selected.length > 0 ? `  ${import_picocolors6.default.dim(selected.map(getLabel).join(", "))}` : "";
          return `${title}${import_picocolors6.default.gray(S_BAR)}${label}`;
        }
        case "cancel": {
          const userInputText = userInput ? `  ${import_picocolors6.default.strikethrough(import_picocolors6.default.dim(userInput))}` : "";
          return `${title}${import_picocolors6.default.gray(S_BAR)}${userInputText}`;
        }
        default: {
          let searchText = "";
          if (this.isNavigating || showPlaceholder) {
            const searchTextValue = showPlaceholder ? placeholder : userInput;
            searchText = searchTextValue !== "" ? ` ${import_picocolors6.default.dim(searchTextValue)}` : "";
          } else {
            searchText = ` ${this.userInputWithCursor}`;
          }
          const matches = this.filteredOptions.length !== options.length ? import_picocolors6.default.dim(` (${this.filteredOptions.length} match${this.filteredOptions.length === 1 ? "" : "es"})`) : "";
          const displayOptions = this.filteredOptions.length === 0 ? [] : limitOptions({
            cursor: this.cursor,
            options: this.filteredOptions,
            style: (option, active) => {
              const label = getLabel(option);
              const hint = option.hint && option.value === this.focusedValue ? import_picocolors6.default.dim(` (${option.hint})`) : "";
              return active ? `${import_picocolors6.default.green(S_RADIO_ACTIVE)} ${label}${hint}` : `${import_picocolors6.default.dim(S_RADIO_INACTIVE)} ${import_picocolors6.default.dim(label)}${hint}`;
            },
            maxItems: opts.maxItems,
            output: opts.output
          });
          const instructions = [
            `${import_picocolors6.default.dim("↑/↓")} to select`,
            `${import_picocolors6.default.dim("Enter:")} confirm`,
            `${import_picocolors6.default.dim("Type:")} to search`
          ];
          const noResults = this.filteredOptions.length === 0 && userInput ? [`${import_picocolors6.default.cyan(S_BAR)}  ${import_picocolors6.default.yellow("No matches found")}`] : [];
          const validationError = this.state === "error" ? [`${import_picocolors6.default.yellow(S_BAR)}  ${import_picocolors6.default.yellow(this.error)}`] : [];
          return [
            `${title}${import_picocolors6.default.cyan(S_BAR)}`,
            `${import_picocolors6.default.cyan(S_BAR)}  ${import_picocolors6.default.dim("Search:")}${searchText}${matches}`,
            ...noResults,
            ...validationError,
            ...displayOptions.map((option) => `${import_picocolors6.default.cyan(S_BAR)}  ${option}`),
            `${import_picocolors6.default.cyan(S_BAR)}  ${import_picocolors6.default.dim(instructions.join(" • "))}`,
            `${import_picocolors6.default.cyan(S_BAR_END)}`
          ].join(`
`);
        }
      }
    }
  });
  return prompt.prompt();
}
function autocompleteMultiselect(opts) {
  const formatOption = (option, active, selectedValues, focusedValue) => {
    const isSelected = selectedValues.includes(option.value);
    const label = option.label ?? String(option.value ?? "");
    const hint = option.hint && focusedValue !== undefined && option.value === focusedValue ? import_picocolors6.default.dim(` (${option.hint})`) : "";
    const checkbox = isSelected ? import_picocolors6.default.green(S_CHECKBOX_SELECTED) : import_picocolors6.default.dim(S_CHECKBOX_INACTIVE);
    if (active) {
      return `${checkbox} ${label}${hint}`;
    }
    return `${checkbox} ${import_picocolors6.default.dim(label)}`;
  };
  const prompt = new AutocompletePrompt({
    options: opts.options,
    multiple: true,
    filter: (search, opt) => {
      return getFilteredOption(search, opt);
    },
    validate: () => {
      if (opts.required && prompt.selectedValues.length === 0) {
        return "Please select at least one item";
      }
      return;
    },
    initialValue: opts.initialValues,
    signal: opts.signal,
    input: opts.input,
    output: opts.output,
    render() {
      const title = `${import_picocolors6.default.gray(S_BAR)}
${symbol(this.state)}  ${opts.message}
`;
      const userInput = this.userInput;
      const placeholder = opts.placeholder;
      const showPlaceholder = userInput === "" && placeholder !== undefined;
      const searchText = this.isNavigating || showPlaceholder ? import_picocolors6.default.dim(showPlaceholder ? placeholder : userInput) : this.userInputWithCursor;
      const options = this.options;
      const matches = this.filteredOptions.length !== options.length ? import_picocolors6.default.dim(` (${this.filteredOptions.length} match${this.filteredOptions.length === 1 ? "" : "es"})`) : "";
      switch (this.state) {
        case "submit": {
          return `${title}${import_picocolors6.default.gray(S_BAR)}  ${import_picocolors6.default.dim(`${this.selectedValues.length} items selected`)}`;
        }
        case "cancel": {
          return `${title}${import_picocolors6.default.gray(S_BAR)}  ${import_picocolors6.default.strikethrough(import_picocolors6.default.dim(userInput))}`;
        }
        default: {
          const instructions = [
            `${import_picocolors6.default.dim("↑/↓")} to navigate`,
            `${import_picocolors6.default.dim("Space:")} select`,
            `${import_picocolors6.default.dim("Enter:")} confirm`,
            `${import_picocolors6.default.dim("Type:")} to search`
          ];
          const noResults = this.filteredOptions.length === 0 && userInput ? [`${import_picocolors6.default.cyan(S_BAR)}  ${import_picocolors6.default.yellow("No matches found")}`] : [];
          const errorMessage = this.state === "error" ? [`${import_picocolors6.default.cyan(S_BAR)}  ${import_picocolors6.default.yellow(this.error)}`] : [];
          const displayOptions = limitOptions({
            cursor: this.cursor,
            options: this.filteredOptions,
            style: (option, active) => formatOption(option, active, this.selectedValues, this.focusedValue),
            maxItems: opts.maxItems,
            output: opts.output
          });
          return [
            title,
            `${import_picocolors6.default.cyan(S_BAR)}  ${import_picocolors6.default.dim("Search:")} ${searchText}${matches}`,
            ...noResults,
            ...errorMessage,
            ...displayOptions.map((option) => `${import_picocolors6.default.cyan(S_BAR)}  ${option}`),
            `${import_picocolors6.default.cyan(S_BAR)}  ${import_picocolors6.default.dim(instructions.join(" • "))}`,
            `${import_picocolors6.default.cyan(S_BAR_END)}`
          ].join(`
`);
        }
      }
    }
  });
  return prompt.prompt();
}
// src/prompts/confirm.ts
var import_picocolors7 = __toESM(require_picocolors(), 1);
function confirm(opts) {
  const active = opts.active ?? "Yes";
  const inactive = opts.inactive ?? "No";
  const message = processMarkdown(opts.message);
  return new ConfirmPrompt({
    active,
    inactive,
    signal: opts.signal,
    input: opts.input,
    output: opts.output,
    initialValue: opts.initialValue ?? true,
    render() {
      const title = `${import_picocolors7.default.gray(S_BAR)}
${symbol(this.state)}  ${message}
`;
      const value = this.value ? active : inactive;
      switch (this.state) {
        case "submit":
          return `${title}${import_picocolors7.default.gray(S_BAR)}  ${import_picocolors7.default.dim(value)}`;
        case "cancel":
          return `${title}${import_picocolors7.default.gray(S_BAR)}  ${import_picocolors7.default.strikethrough(import_picocolors7.default.dim(value))}
${import_picocolors7.default.gray(S_BAR)}`;
        default: {
          return `${title}${import_picocolors7.default.cyan(S_BAR)}  ${this.value ? `${import_picocolors7.default.green(S_RADIO_ACTIVE)} ${active}` : `${import_picocolors7.default.dim(S_RADIO_INACTIVE)} ${import_picocolors7.default.dim(active)}`} ${import_picocolors7.default.dim("/")} ${!this.value ? `${import_picocolors7.default.green(S_RADIO_ACTIVE)} ${inactive}` : `${import_picocolors7.default.dim(S_RADIO_INACTIVE)} ${import_picocolors7.default.dim(inactive)}`}
${import_picocolors7.default.cyan(S_BAR_END)}
`;
        }
      }
    }
  }).prompt();
}
// src/prompts/group.ts
async function group(prompts2, opts) {
  const results = {};
  const promptNames = Object.keys(prompts2);
  for (const name of promptNames) {
    const prompt = prompts2[name];
    const result = await prompt({ results })?.catch((e) => {
      throw e;
    });
    if (typeof opts?.onCancel === "function" && isCancel(result)) {
      results[name] = "canceled";
      opts.onCancel({ results });
      continue;
    }
    results[name] = result;
  }
  return results;
}
// src/prompts/group-multi-select.ts
var import_picocolors8 = __toESM(require_picocolors(), 1);
function groupMultiselect(opts) {
  const { selectableGroups = true, groupSpacing = 0 } = opts;
  const opt = (option, state, options = []) => {
    const label = option.label ?? String(option.value);
    const isItem = typeof option.group === "string";
    const next = isItem && (options[options.indexOf(option) + 1] ?? { group: true });
    const isLast = isItem && next.group === true;
    const prefix = isItem ? selectableGroups ? `${isLast ? S_BAR_END : S_BAR} ` : "  " : "";
    let spacingPrefix = "";
    if (groupSpacing > 0 && !isItem) {
      const spacingPrefixText = `
${import_picocolors8.default.cyan(S_BAR)}`;
      spacingPrefix = `${spacingPrefixText.repeat(groupSpacing - 1)}${spacingPrefixText}  `;
    }
    if (state === "active") {
      return `${spacingPrefix}${import_picocolors8.default.dim(prefix)}${import_picocolors8.default.cyan(S_CHECKBOX_ACTIVE)} ${label}${option.hint ? ` ${import_picocolors8.default.dim(`(${option.hint})`)}` : ""}`;
    }
    if (state === "group-active") {
      return `${spacingPrefix}${prefix}${import_picocolors8.default.cyan(S_CHECKBOX_ACTIVE)} ${import_picocolors8.default.dim(label)}`;
    }
    if (state === "group-active-selected") {
      return `${spacingPrefix}${prefix}${import_picocolors8.default.green(S_CHECKBOX_SELECTED)} ${import_picocolors8.default.dim(label)}`;
    }
    if (state === "selected") {
      const selectedCheckbox = isItem || selectableGroups ? import_picocolors8.default.green(S_CHECKBOX_SELECTED) : "";
      return `${spacingPrefix}${import_picocolors8.default.dim(prefix)}${selectedCheckbox} ${import_picocolors8.default.dim(label)}${option.hint ? ` ${import_picocolors8.default.dim(`(${option.hint})`)}` : ""}`;
    }
    if (state === "cancelled") {
      return `${import_picocolors8.default.strikethrough(import_picocolors8.default.dim(label))}`;
    }
    if (state === "active-selected") {
      return `${spacingPrefix}${import_picocolors8.default.dim(prefix)}${import_picocolors8.default.green(S_CHECKBOX_SELECTED)} ${label}${option.hint ? ` ${import_picocolors8.default.dim(`(${option.hint})`)}` : ""}`;
    }
    if (state === "submitted") {
      return `${import_picocolors8.default.dim(label)}`;
    }
    const unselectedCheckbox = isItem || selectableGroups ? import_picocolors8.default.dim(S_CHECKBOX_INACTIVE) : "";
    return `${spacingPrefix}${import_picocolors8.default.dim(prefix)}${unselectedCheckbox} ${import_picocolors8.default.dim(label)}`;
  };
  const required = opts.required ?? true;
  return new GroupMultiSelectPrompt({
    options: opts.options,
    signal: opts.signal,
    input: opts.input,
    output: opts.output,
    initialValues: opts.initialValues,
    required,
    cursorAt: opts.cursorAt,
    selectableGroups,
    validate(selected) {
      if (required && (selected === undefined || selected.length === 0)) {
        return `Please select at least one option.
${import_picocolors8.default.reset(import_picocolors8.default.dim(`Press ${import_picocolors8.default.gray(import_picocolors8.default.bgWhite(import_picocolors8.default.inverse(" space ")))} to select, ${import_picocolors8.default.gray(import_picocolors8.default.bgWhite(import_picocolors8.default.inverse(" enter ")))} to submit`))}`;
      }
    },
    render() {
      const title = `${import_picocolors8.default.gray(S_BAR)}
${symbol(this.state)}  ${opts.message}
`;
      const value = this.value ?? [];
      switch (this.state) {
        case "submit": {
          const selectedOptions = this.options.filter(({ value: optionValue }) => value.includes(optionValue)).map((option) => opt(option, "submitted"));
          const optionsText = selectedOptions.length === 0 ? "" : `  ${selectedOptions.join(import_picocolors8.default.dim(", "))}`;
          return `${title}${import_picocolors8.default.gray(S_BAR)}${optionsText}`;
        }
        case "cancel": {
          const label = this.options.filter(({ value: optionValue }) => value.includes(optionValue)).map((option) => opt(option, "cancelled")).join(import_picocolors8.default.dim(", "));
          return `${title}${import_picocolors8.default.gray(S_BAR)}  ${label.trim() ? `${label}
${import_picocolors8.default.gray(S_BAR)}` : ""}`;
        }
        case "error": {
          const footer = this.error.split(`
`).map((ln, i) => i === 0 ? `${import_picocolors8.default.yellow(S_BAR_END)}  ${import_picocolors8.default.yellow(ln)}` : `   ${ln}`).join(`
`);
          return `${title}${import_picocolors8.default.yellow(S_BAR)}  ${this.options.map((option, i, options) => {
            const selected = value.includes(option.value) || option.group === true && this.isGroupSelected(`${option.value}`);
            const active = i === this.cursor;
            const groupActive = !active && typeof option.group === "string" && this.options[this.cursor].value === option.group;
            if (groupActive) {
              return opt(option, selected ? "group-active-selected" : "group-active", options);
            }
            if (active && selected) {
              return opt(option, "active-selected", options);
            }
            if (selected) {
              return opt(option, "selected", options);
            }
            return opt(option, active ? "active" : "inactive", options);
          }).join(`
${import_picocolors8.default.yellow(S_BAR)}  `)}
${footer}
`;
        }
        default: {
          const optionsText = this.options.map((option, i, options) => {
            const selected = value.includes(option.value) || option.group === true && this.isGroupSelected(`${option.value}`);
            const active = i === this.cursor;
            const groupActive = !active && typeof option.group === "string" && this.options[this.cursor].value === option.group;
            let optionText = "";
            if (groupActive) {
              optionText = opt(option, selected ? "group-active-selected" : "group-active", options);
            } else if (active && selected) {
              optionText = opt(option, "active-selected", options);
            } else if (selected) {
              optionText = opt(option, "selected", options);
            } else {
              optionText = opt(option, active ? "active" : "inactive", options);
            }
            const prefix = i !== 0 && !optionText.startsWith(`
`) ? "  " : "";
            return `${prefix}${optionText}`;
          }).join(`
${import_picocolors8.default.cyan(S_BAR)}`);
          const optionsPrefix = optionsText.startsWith(`
`) ? "" : "  ";
          return `${title}${import_picocolors8.default.cyan(S_BAR)}${optionsPrefix}${optionsText}
${import_picocolors8.default.cyan(S_BAR_END)}
`;
        }
      }
    }
  }).prompt();
}
// src/prompts/log.ts
var import_picocolors9 = __toESM(require_picocolors(), 1);
import process9 from "node:process";
function processMessage(message) {
  if (Array.isArray(message)) {
    return message.map((m) => processMarkdown(m));
  }
  return processMarkdown(message);
}
var log = {
  message: (message = [], {
    symbol: symbol2 = import_picocolors9.default.gray(S_BAR),
    secondarySymbol = import_picocolors9.default.gray(S_BAR),
    output = process9.stdout,
    spacing = 1
  } = {}) => {
    const parts = [];
    for (let i = 0;i < spacing; i++) {
      parts.push(`${secondarySymbol}`);
    }
    const processedMessage = processMessage(message);
    const messageParts = Array.isArray(processedMessage) ? processedMessage : processedMessage.split(`
`);
    if (messageParts.length > 0) {
      const [firstLine, ...lines] = messageParts;
      if (firstLine.length > 0) {
        parts.push(`${symbol2}  ${firstLine}`);
      } else {
        parts.push(symbol2);
      }
      for (const ln of lines) {
        if (ln.length > 0) {
          parts.push(`${secondarySymbol}  ${ln}`);
        } else {
          parts.push(secondarySymbol);
        }
      }
    }
    output.write(`${parts.join(`
`)}
`);
  },
  info: (message, opts) => {
    log.message(message, { ...opts, symbol: import_picocolors9.default.blue(S_INFO) });
  },
  success: (message, opts) => {
    log.message(message, { ...opts, symbol: import_picocolors9.default.green(S_SUCCESS) });
  },
  step: (message, opts) => {
    log.message(message, { ...opts, symbol: import_picocolors9.default.green(S_STEP_SUBMIT) });
  },
  warn: (message, opts) => {
    log.message(message, { ...opts, symbol: import_picocolors9.default.yellow(S_WARN) });
  },
  warning: (message, opts) => {
    log.warn(message, opts);
  },
  error: (message, opts) => {
    log.message(message, { ...opts, symbol: import_picocolors9.default.red(S_ERROR) });
  },
  custom: (symbol2, message, color9, opts) => {
    const colorFn = typeof color9 === "string" ? (text) => import_picocolors9.default[color9]?.(text) || text : color9;
    log.message(message, {
      ...opts,
      symbol: colorFn(symbol2),
      secondarySymbol: colorFn(symbol2)
    });
  }
};
// src/prompts/messages.ts
var import_picocolors10 = __toESM(require_picocolors(), 1);
import process10 from "node:process";
function cancel(message = "", opts) {
  const output = opts?.output ?? process10.stdout;
  output.write(`${import_picocolors10.default.gray(S_BAR_END)}  ${import_picocolors10.default.red(message)}

`);
}
function intro(title = "", opts) {
  const output = opts?.output ?? process10.stdout;
  output.write(`${import_picocolors10.default.gray(S_BAR_START)}  ${title}
`);
}
function outro(message = "", opts) {
  const output = opts?.output ?? process10.stdout;
  output.write(`${import_picocolors10.default.gray(S_BAR)}
${import_picocolors10.default.gray(S_BAR_END)}  ${message}

`);
}
// src/prompts/multi-select.ts
var import_picocolors11 = __toESM(require_picocolors(), 1);
function multiselect(opts) {
  const opt = (option, state) => {
    const label = option.label ?? String(option.value);
    if (state === "active") {
      return `${import_picocolors11.default.cyan(S_CHECKBOX_ACTIVE)} ${label}${option.hint ? ` ${import_picocolors11.default.dim(`(${option.hint})`)}` : ""}`;
    }
    if (state === "selected") {
      return `${import_picocolors11.default.green(S_CHECKBOX_SELECTED)} ${import_picocolors11.default.dim(label)}${option.hint ? ` ${import_picocolors11.default.dim(`(${option.hint})`)}` : ""}`;
    }
    if (state === "cancelled") {
      return `${import_picocolors11.default.strikethrough(import_picocolors11.default.dim(label))}`;
    }
    if (state === "active-selected") {
      return `${import_picocolors11.default.green(S_CHECKBOX_SELECTED)} ${label}${option.hint ? ` ${import_picocolors11.default.dim(`(${option.hint})`)}` : ""}`;
    }
    if (state === "submitted") {
      return `${import_picocolors11.default.dim(label)}`;
    }
    return `${import_picocolors11.default.dim(S_CHECKBOX_INACTIVE)} ${import_picocolors11.default.dim(label)}`;
  };
  const required = opts.required ?? true;
  return new MultiSelectPrompt({
    options: opts.options,
    input: opts.input,
    output: opts.output,
    initialValues: opts.initialValues,
    required,
    cursorAt: opts.cursorAt,
    validate(selected) {
      if (required && (selected === undefined || selected.length === 0)) {
        return `Please select at least one option.
${import_picocolors11.default.reset(import_picocolors11.default.dim(`Press ${import_picocolors11.default.gray(import_picocolors11.default.bgWhite(import_picocolors11.default.inverse(" space ")))} to select, ${import_picocolors11.default.gray(import_picocolors11.default.bgWhite(import_picocolors11.default.inverse(" enter ")))} to submit`))}`;
      }
    },
    render() {
      const title = `${import_picocolors11.default.gray(S_BAR)}
${symbol(this.state)}  ${opts.message}
`;
      const value = this.value ?? [];
      const styleOption = (option, active) => {
        const selected = value.includes(option.value);
        if (active && selected) {
          return opt(option, "active-selected");
        }
        if (selected) {
          return opt(option, "selected");
        }
        return opt(option, active ? "active" : "inactive");
      };
      switch (this.state) {
        case "submit": {
          return `${title}${import_picocolors11.default.gray(S_BAR)}  ${this.options.filter(({ value: optionValue }) => value.includes(optionValue)).map((option) => opt(option, "submitted")).join(import_picocolors11.default.dim(", ")) || import_picocolors11.default.dim("none")}`;
        }
        case "cancel": {
          const label = this.options.filter(({ value: optionValue }) => value.includes(optionValue)).map((option) => opt(option, "cancelled")).join(import_picocolors11.default.dim(", "));
          return `${title}${import_picocolors11.default.gray(S_BAR)}${label.trim() ? `  ${label}
${import_picocolors11.default.gray(S_BAR)}` : ""}`;
        }
        case "error": {
          const footer = this.error.split(`
`).map((ln, i) => i === 0 ? `${import_picocolors11.default.yellow(S_BAR_END)}  ${import_picocolors11.default.yellow(ln)}` : `   ${ln}`).join(`
`);
          return `${title + import_picocolors11.default.yellow(S_BAR)}  ${limitOptions({
            output: opts.output,
            options: this.options,
            cursor: this.cursor,
            maxItems: opts.maxItems,
            style: styleOption
          }).join(`
${import_picocolors11.default.yellow(S_BAR)}  `)}
${footer}
`;
        }
        default: {
          return `${title}${import_picocolors11.default.cyan(S_BAR)}  ${limitOptions({
            output: opts.output,
            options: this.options,
            cursor: this.cursor,
            maxItems: opts.maxItems,
            style: styleOption
          }).join(`
${import_picocolors11.default.cyan(S_BAR)}  `)}
${import_picocolors11.default.cyan(S_BAR_END)}
`;
        }
      }
    }
  }).prompt();
}
// src/prompts/note.ts
var import_picocolors12 = __toESM(require_picocolors(), 1);
import process11 from "node:process";
import { stripVTControlCharacters as strip } from "node:util";
var defaultNoteFormatter = (line) => import_picocolors12.default.dim(line);
function note(message = "", title = "", opts) {
  const format = opts?.format ?? defaultNoteFormatter;
  const processedMessage = processMarkdown(message);
  const processedTitle = processMarkdown(title);
  const lines = ["", ...processedMessage.split(`
`).map(format), ""];
  const titleLen = strip(processedTitle).length;
  const output = opts?.output ?? process11.stdout;
  const len = Math.max(lines.reduce((sum, ln) => {
    const line = strip(ln);
    return line.length > sum ? line.length : sum;
  }, 0), titleLen) + 2;
  const msg = lines.map((ln) => `${import_picocolors12.default.gray(S_BAR)}  ${ln}${" ".repeat(len - strip(ln).length)}${import_picocolors12.default.gray(S_BAR)}`).join(`
`);
  output.write(`${import_picocolors12.default.gray(S_BAR)}
${import_picocolors12.default.green(S_STEP_SUBMIT)}  ${import_picocolors12.default.reset(processedTitle)} ${import_picocolors12.default.gray(S_BAR_H.repeat(Math.max(len - titleLen - 1, 1)) + S_CORNER_TOP_RIGHT)}
${msg}
${import_picocolors12.default.gray(S_CONNECT_LEFT + S_BAR_H.repeat(len + 2) + S_CORNER_BOTTOM_RIGHT)}
`);
}
// src/prompts/password.ts
var import_picocolors13 = __toESM(require_picocolors(), 1);
function password(opts) {
  return new PasswordPrompt({
    validate: opts.validate,
    mask: opts.mask ?? S_PASSWORD_MASK,
    signal: opts.signal,
    input: opts.input,
    output: opts.output,
    render() {
      const title = `${import_picocolors13.default.gray(S_BAR)}
${symbol(this.state)}  ${opts.message}
`;
      const userInput = this.userInputWithCursor;
      const masked = this.masked;
      switch (this.state) {
        case "error": {
          const maskedText = masked ? `  ${masked}` : "";
          return `${title.trim()}
${import_picocolors13.default.yellow(S_BAR)}${maskedText}
${import_picocolors13.default.yellow(S_BAR_END)}  ${import_picocolors13.default.yellow(this.error)}
`;
        }
        case "submit": {
          const maskedText = masked ? `  ${import_picocolors13.default.dim(masked)}` : "";
          return `${title}${import_picocolors13.default.gray(S_BAR)}${maskedText}`;
        }
        case "cancel": {
          const maskedText = masked ? `  ${import_picocolors13.default.strikethrough(import_picocolors13.default.dim(masked))}` : "";
          return `${title}${import_picocolors13.default.gray(S_BAR)}${maskedText}${masked ? `
${import_picocolors13.default.gray(S_BAR)}` : ""}`;
        }
        default:
          return `${title}${import_picocolors13.default.cyan(S_BAR)}  ${userInput}
${import_picocolors13.default.cyan(S_BAR_END)}
`;
      }
    }
  }).prompt();
}
// src/prompts/path.ts
import { existsSync, lstatSync, readdirSync } from "node:fs";
import { dirname, join } from "node:path";
import process12 from "node:process";
function path(opts) {
  const validate2 = opts.validate;
  return autocomplete({
    ...opts,
    initialUserInput: opts.initialValue ?? opts.root ?? process12.cwd(),
    maxItems: 5,
    validate(value) {
      if (Array.isArray(value)) {
        return;
      }
      if (!value) {
        return "Please select a path";
      }
      if (validate2) {
        return validate2(value);
      }
      return;
    },
    options() {
      const userInput = this.userInput;
      if (userInput === "") {
        return [];
      }
      try {
        let searchPath;
        if (!existsSync(userInput)) {
          searchPath = dirname(userInput);
        } else {
          const stat = lstatSync(userInput);
          if (stat.isDirectory()) {
            searchPath = userInput;
          } else {
            searchPath = dirname(userInput);
          }
        }
        const items = readdirSync(searchPath).map((item) => {
          const path2 = join(searchPath, item);
          const stats = lstatSync(path2);
          return {
            name: item,
            path: path2,
            isDirectory: stats.isDirectory()
          };
        }).filter(({ path: path2, isDirectory }) => path2.startsWith(userInput) && (opts.directory || !isDirectory));
        return items.map((item) => ({
          value: item.path
        }));
      } catch {
        return [];
      }
    }
  });
}
// src/prompts/progress-bar.ts
var import_picocolors15 = __toESM(require_picocolors(), 1);

// src/prompts/spinner.ts
var import_picocolors14 = __toESM(require_picocolors(), 1);
import process13 from "node:process";
function spinner({
  indicator = "dots",
  onCancel,
  output = process13.stdout,
  cancelMessage,
  errorMessage,
  frames = unicode ? ["◒", "◐", "◓", "◑"] : ["•", "o", "O", "0"],
  delay = unicode ? 80 : 120,
  signal
} = {}) {
  const isCI2 = isCI();
  let unblock;
  let loop;
  let isSpinnerActive = false;
  let isCancelled = false;
  let _message = "";
  let _prevMessage;
  let _origin = performance.now();
  function clearPrevMessage() {
    if (_prevMessage === undefined)
      return;
    if (isCI2)
      output.write(`
`);
    const prevLines = _prevMessage.split(`
`);
    output.write(cursor.move(-999, prevLines.length - 1));
    output.write(erase.down(prevLines.length));
  }
  function removeTrailingDots(msg) {
    return msg.replace(/\.+$/, "");
  }
  function formatTimer(origin) {
    const duration = (performance.now() - origin) / 1000;
    const min = Math.floor(duration / 60);
    const secs = Math.floor(duration % 60);
    return min > 0 ? `[${min}m ${secs}s]` : `[${secs}s]`;
  }
  function stop(msg = "", code = 0) {
    isSpinnerActive = false;
    clearInterval(loop);
    clearPrevMessage();
    const step = code === 0 ? import_picocolors14.default.green(S_STEP_SUBMIT) : code === 1 ? import_picocolors14.default.red(S_STEP_CANCEL) : import_picocolors14.default.red(S_STEP_ERROR);
    _message = msg ?? _message;
    if (indicator === "timer") {
      output.write(`${step}  ${_message} ${formatTimer(_origin)}
`);
    } else {
      output.write(`${step}  ${_message}
`);
    }
    clearHooks();
    unblock();
  }
  function handleExit(code) {
    const msg = code > 1 ? errorMessage ?? settings.messages.error : cancelMessage ?? settings.messages.cancel;
    isCancelled = code === 1;
    if (isSpinnerActive) {
      stop(msg, code);
      if (isCancelled && typeof onCancel === "function") {
        onCancel();
      }
    }
  }
  function errorEventHandler() {
    handleExit(2);
  }
  function signalEventHandler() {
    handleExit(1);
  }
  function registerHooks() {
    process13.on("uncaughtExceptionMonitor", errorEventHandler);
    process13.on("unhandledRejection", errorEventHandler);
    process13.on("SIGINT", signalEventHandler);
    process13.on("SIGTERM", signalEventHandler);
    process13.on("exit", handleExit);
  }
  function clearHooks() {
    process13.removeListener("uncaughtExceptionMonitor", errorEventHandler);
    process13.removeListener("unhandledRejection", errorEventHandler);
    process13.removeListener("SIGINT", signalEventHandler);
    process13.removeListener("SIGTERM", signalEventHandler);
    process13.removeListener("exit", handleExit);
    if (signal) {
      signal.removeEventListener("abort", signalEventHandler);
    }
  }
  function start(msg = "") {
    isSpinnerActive = true;
    unblock = block({ output });
    _message = removeTrailingDots(msg);
    _origin = performance.now();
    output.write(`${import_picocolors14.default.gray(S_BAR)}
`);
    let frameIndex = 0;
    let indicatorTimer = 0;
    registerHooks();
    loop = setInterval(() => {
      if (isCI2 && _message === _prevMessage) {
        return;
      }
      clearPrevMessage();
      _prevMessage = _message;
      const frame = import_picocolors14.default.magenta(frames[frameIndex]);
      if (isCI2) {
        output.write(`${frame}  ${_message}...`);
      } else if (indicator === "timer") {
        output.write(`${frame}  ${_message} ${formatTimer(_origin)}`);
      } else {
        const loadingDots = ".".repeat(Math.floor(indicatorTimer)).slice(0, 3);
        output.write(`${frame}  ${_message}${loadingDots}`);
      }
      frameIndex = frameIndex + 1 < frames.length ? frameIndex + 1 : 0;
      indicatorTimer = indicatorTimer < 4 ? indicatorTimer + 0.125 : 0;
    }, delay);
  }
  function message(msg = "") {
    _message = removeTrailingDots(msg ?? _message);
  }
  return {
    start,
    stop,
    message,
    get isCancelled() {
      return isCancelled;
    }
  };
}

// src/prompts/progress-bar.ts
var S_PROGRESS_CHAR = {
  light: unicodeOr("─", "-"),
  heavy: unicodeOr("━", "="),
  block: unicodeOr("█", "#")
};
function progress(options = {}) {
  const {
    style: style2 = "heavy",
    max: userMax = 100,
    size: userSize = 40,
    ...spinnerOptions
  } = options;
  const spin = spinner(spinnerOptions);
  let value = 0;
  let previousMessage = "";
  const max = Math.max(1, userMax);
  const size = Math.max(1, userSize);
  const activeStyle = (state) => {
    switch (state) {
      case "initial":
      case "active":
        return import_picocolors15.default.magenta;
      case "error":
      case "cancel":
        return import_picocolors15.default.red;
      case "submit":
        return import_picocolors15.default.green;
      default:
        return import_picocolors15.default.magenta;
    }
  };
  const drawProgress = (state, msg) => {
    const active = Math.floor(value / max * size);
    return `${activeStyle(state)(S_PROGRESS_CHAR[style2].repeat(active))}${import_picocolors15.default.dim(S_PROGRESS_CHAR[style2].repeat(size - active))} ${msg}`;
  };
  const start = (msg = "") => {
    previousMessage = msg;
    return spin.start(drawProgress("initial", msg));
  };
  const advance = (step = 1, msg) => {
    value = Math.min(max, step + value);
    spin.message(drawProgress("active", msg ?? previousMessage));
    previousMessage = msg ?? previousMessage;
  };
  return {
    start,
    stop: spin.stop,
    advance,
    isCancelled: spin.isCancelled,
    message: (msg) => advance(0, msg)
  };
}
// src/prompts/select.ts
var import_picocolors16 = __toESM(require_picocolors(), 1);
function select(opts) {
  const message = processMarkdown(opts.message);
  const opt = (option, state) => {
    const label = option.label ?? String(option.value);
    switch (state) {
      case "selected":
        return `${import_picocolors16.default.dim(label)}`;
      case "active":
        return `${import_picocolors16.default.green(S_RADIO_ACTIVE)} ${label}${option.hint ? ` ${import_picocolors16.default.dim(`(${option.hint})`)}` : ""}`;
      case "cancelled":
        return `${import_picocolors16.default.strikethrough(import_picocolors16.default.dim(label))}`;
      default:
        return `${import_picocolors16.default.dim(S_RADIO_INACTIVE)} ${import_picocolors16.default.dim(label)}`;
    }
  };
  return new SelectPrompt({
    options: opts.options,
    signal: opts.signal,
    input: opts.input,
    output: opts.output,
    initialValue: opts.initialValue,
    render() {
      const title = `${import_picocolors16.default.gray(S_BAR)}
${symbol(this.state)}  ${message}
`;
      switch (this.state) {
        case "submit":
          return `${title}${import_picocolors16.default.gray(S_BAR)}  ${opt(this.options[this.cursor], "selected")}`;
        case "cancel":
          return `${title}${import_picocolors16.default.gray(S_BAR)}  ${opt(this.options[this.cursor], "cancelled")}
${import_picocolors16.default.gray(S_BAR)}`;
        default: {
          return `${title}${import_picocolors16.default.cyan(S_BAR)}  ${limitOptions({
            output: opts.output,
            cursor: this.cursor,
            options: this.options,
            maxItems: opts.maxItems,
            style: (item, active) => opt(item, active ? "active" : "inactive")
          }).join(`
${import_picocolors16.default.cyan(S_BAR)}  `)}
${import_picocolors16.default.cyan(S_BAR_END)}
`;
        }
      }
    }
  }).prompt();
}
// src/prompts/select-key.ts
var import_picocolors17 = __toESM(require_picocolors(), 1);
function selectKey(opts) {
  const opt = (option, state = "inactive") => {
    const label = option.label ?? String(option.value);
    if (state === "selected") {
      return `${import_picocolors17.default.dim(label)}`;
    }
    if (state === "cancelled") {
      return `${import_picocolors17.default.strikethrough(import_picocolors17.default.dim(label))}`;
    }
    if (state === "active") {
      return `${import_picocolors17.default.bgCyan(import_picocolors17.default.gray(` ${option.value} `))} ${label} ${option.hint ? import_picocolors17.default.dim(`(${option.hint})`) : ""}`;
    }
    return `${import_picocolors17.default.gray(import_picocolors17.default.bgWhite(import_picocolors17.default.inverse(` ${option.value} `)))} ${label} ${option.hint ? import_picocolors17.default.dim(`(${option.hint})`) : ""}`;
  };
  return new SelectKeyPrompt({
    options: opts.options,
    signal: opts.signal,
    input: opts.input,
    output: opts.output,
    initialValue: opts.initialValue,
    render() {
      const title = `${import_picocolors17.default.gray(S_BAR)}
${symbol(this.state)}  ${opts.message}
`;
      switch (this.state) {
        case "submit":
          return `${title}${import_picocolors17.default.gray(S_BAR)}  ${opt(this.options.find((opt2) => opt2.value === this.value) ?? opts.options[0], "selected")}`;
        case "cancel":
          return `${title}${import_picocolors17.default.gray(S_BAR)}  ${opt(this.options[0], "cancelled")}
${import_picocolors17.default.gray(S_BAR)}`;
        default: {
          return `${title}${import_picocolors17.default.cyan(S_BAR)}  ${this.options.map((option, i) => opt(option, i === this.cursor ? "active" : "inactive")).join(`
${import_picocolors17.default.cyan(S_BAR)}  `)}
${import_picocolors17.default.cyan(S_BAR_END)}
`;
        }
      }
    }
  }).prompt();
}
// src/prompts/stream.ts
var import_picocolors18 = __toESM(require_picocolors(), 1);
import process14 from "node:process";
import { stripVTControlCharacters as strip2 } from "node:util";
function getPrefix() {
  return `${import_picocolors18.default.gray(S_BAR)}  `;
}
var prefix = getPrefix();
var stream = {
  message: async (iterable, { symbol: symbol2 = import_picocolors18.default.gray(S_BAR) } = {}) => {
    process14.stdout.write(`${import_picocolors18.default.gray(S_BAR)}
${symbol2}  `);
    let lineWidth = 3;
    for await (let chunk of iterable) {
      chunk = chunk.replace(/\n/g, `
${prefix}`);
      if (chunk.includes(`
`)) {
        lineWidth = 3 + strip2(chunk.slice(chunk.lastIndexOf(`
`))).length;
      }
      const chunkLen = strip2(chunk).length;
      if (lineWidth + chunkLen < process14.stdout.columns) {
        lineWidth += chunkLen;
        process14.stdout.write(chunk);
      } else {
        process14.stdout.write(`
${prefix}${chunk.trimStart()}`);
        lineWidth = 3 + strip2(chunk.trimStart()).length;
      }
    }
    process14.stdout.write(`
`);
  },
  info: (iterable) => {
    return stream.message(iterable, { symbol: import_picocolors18.default.blue(S_INFO) });
  },
  success: (iterable) => {
    return stream.message(iterable, { symbol: import_picocolors18.default.green(S_SUCCESS) });
  },
  step: (iterable) => {
    return stream.message(iterable, { symbol: import_picocolors18.default.green(S_STEP_SUBMIT) });
  },
  warn: (iterable) => {
    return stream.message(iterable, { symbol: import_picocolors18.default.yellow(S_WARN) });
  },
  warning: (iterable) => {
    return stream.warn(iterable);
  },
  error: (iterable) => {
    return stream.message(iterable, { symbol: import_picocolors18.default.red(S_ERROR) });
  }
};
// src/prompts/task.ts
async function tasks(tasks2, opts) {
  for (const task of tasks2) {
    if (task.enabled === false)
      continue;
    const s = spinner(opts);
    s.start(task.title);
    const result = await task.task(s.message);
    s.stop(result || task.title);
  }
}
// src/prompts/task-log.ts
var color18 = __toESM(require_picocolors(), 1);
import process15 from "node:process";
function taskLog(opts) {
  const output = opts.output ?? process15.stdout;
  const columns = getColumns(output);
  const secondarySymbol = color18.gray(S_BAR);
  const spacing = opts.spacing ?? 1;
  const barSize = 3;
  const retainLog = opts.retainLog === true;
  const isTTY2 = !isCI() && isTTY(output);
  output.write(`${secondarySymbol}
`);
  output.write(`${color18.green(S_STEP_SUBMIT)}  ${opts.title}
`);
  for (let i = 0;i < spacing; i++) {
    output.write(`${secondarySymbol}
`);
  }
  const buffers = [
    {
      value: "",
      full: ""
    }
  ];
  let lastMessageWasRaw = false;
  const clear2 = (clearTitle) => {
    if (buffers.length === 0) {
      return;
    }
    let lines = 0;
    if (clearTitle) {
      lines += spacing + 2;
    }
    for (const buffer of buffers) {
      const { value, result } = buffer;
      let text = result?.message ?? value;
      if (text.length === 0) {
        continue;
      }
      if (result === undefined && buffer.header !== undefined && buffer.header !== "") {
        text += `
${buffer.header}`;
      }
      const bufferHeight = text.split(`
`).reduce((count, line) => {
        if (line === "") {
          return count + 1;
        }
        return count + Math.ceil((line.length + barSize) / columns);
      }, 0);
      lines += bufferHeight;
    }
    if (lines > 0) {
      lines += 1;
      output.write(erase.lines(lines));
    }
  };
  const printBuffer = (buffer, messageSpacing, full) => {
    const messages = full ? `${buffer.full}
${buffer.value}` : buffer.value;
    if (buffer.header !== undefined && buffer.header !== "") {
      log.message(buffer.header.split(`
`).map(color18.bold), {
        output,
        secondarySymbol,
        symbol: secondarySymbol,
        spacing: 0
      });
    }
    log.message(messages.split(`
`).map(color18.dim), {
      output,
      secondarySymbol,
      symbol: secondarySymbol,
      spacing: messageSpacing ?? spacing
    });
  };
  const renderBuffer = () => {
    for (const buffer of buffers) {
      const { header, value, full } = buffer;
      if ((header === undefined || header.length === 0) && value.length === 0) {
        continue;
      }
      printBuffer(buffer, undefined, retainLog === true && full.length > 0);
    }
  };
  const printBuffers = () => {
    for (const buffer of buffers) {
      if (buffer.result) {
        if (buffer.result.status === "error") {
          log.error(buffer.result.message, { output, secondarySymbol, spacing: 0 });
        } else {
          log.success(buffer.result.message, { output, secondarySymbol, spacing: 0 });
        }
      } else if (buffer.value !== "") {
        printBuffer(buffer, 0);
      }
    }
  };
  const message = (buffer, msg, mopts) => {
    clear2(false);
    if ((mopts?.raw !== true || !lastMessageWasRaw) && buffer.value !== "") {
      buffer.value += `
`;
    }
    buffer.value += msg;
    lastMessageWasRaw = mopts?.raw === true;
    if (opts.limit !== undefined) {
      const lines = buffer.value.split(`
`);
      const linesToRemove = lines.length - opts.limit;
      if (linesToRemove > 0) {
        const removedLines = lines.splice(0, linesToRemove);
        if (retainLog) {
          buffer.full += (buffer.full === "" ? "" : `
`) + removedLines.join(`
`);
        }
      }
      buffer.value = lines.join(`
`);
    }
    if (isTTY2) {
      printBuffers();
    }
  };
  const completeBuffer = (buffer, result) => {
    clear2(false);
    buffer.result = result;
    if (isTTY2) {
      printBuffers();
    }
  };
  return {
    message(msg, mopts) {
      message(buffers[0], msg, mopts);
    },
    group(name) {
      const buffer = {
        header: name,
        value: "",
        full: ""
      };
      buffers.push(buffer);
      return {
        message(msg, mopts) {
          message(buffer, msg, mopts);
        },
        error(message2) {
          completeBuffer(buffer, {
            status: "error",
            message: message2
          });
        },
        success(message2) {
          completeBuffer(buffer, {
            status: "success",
            message: message2
          });
        }
      };
    },
    error(message2, opts2) {
      clear2(true);
      log.error(message2, { output, secondarySymbol, spacing: 1 });
      if (opts2?.showLog !== false) {
        renderBuffer();
      }
      buffers.splice(1, buffers.length - 1);
      buffers[0].value = "";
      buffers[0].full = "";
    },
    success(message2, opts2) {
      clear2(true);
      log.success(message2, { output, secondarySymbol, spacing: 1 });
      if (opts2?.showLog === true) {
        renderBuffer();
      }
      buffers.splice(1, buffers.length - 1);
      buffers[0].value = "";
      buffers[0].full = "";
    }
  };
}
// src/prompts/text.ts
var import_picocolors19 = __toESM(require_picocolors(), 1);
function text(opts) {
  const message = processMarkdown(opts.message);
  return new TextPrompt({
    validate: opts.validate,
    placeholder: opts.placeholder,
    defaultValue: opts.defaultValue,
    initialValue: opts.initialValue,
    output: opts.output,
    signal: opts.signal,
    input: opts.input,
    render() {
      const title = `${import_picocolors19.default.gray(S_BAR)}
${symbol(this.state)}  ${message}
`;
      const placeholder = opts.placeholder ? import_picocolors19.default.inverse(opts.placeholder[0]) + import_picocolors19.default.dim(opts.placeholder.slice(1)) : import_picocolors19.default.inverse(import_picocolors19.default.hidden("_"));
      const userInput = !this.userInput ? placeholder : this.userInputWithCursor;
      const value = this.value ?? "";
      switch (this.state) {
        case "error": {
          const errorText = this.error ? `  ${import_picocolors19.default.yellow(this.error)}` : "";
          return `${title.trim()}
${import_picocolors19.default.yellow(S_BAR)}  ${userInput}
${import_picocolors19.default.yellow(S_BAR_END)}${errorText}
`;
        }
        case "submit": {
          const shouldShowValue = this.userInput || value !== opts.placeholder;
          const valueText = shouldShowValue && value ? `  ${import_picocolors19.default.dim(value)}` : "";
          return `${title}${import_picocolors19.default.gray(S_BAR)}${valueText}`;
        }
        case "cancel": {
          const valueText = value ? `  ${import_picocolors19.default.strikethrough(import_picocolors19.default.dim(value))}` : "";
          return `${title}${import_picocolors19.default.gray(S_BAR)}${valueText}${value.trim() ? `
${import_picocolors19.default.gray(S_BAR)}` : ""}`;
        }
        default:
          return `${title}${import_picocolors19.default.cyan(S_BAR)}  ${userInput}
${import_picocolors19.default.cyan(S_BAR_END)}
`;
      }
    }
  }).prompt();
}
// src/testing.ts
import { Buffer } from "node:buffer";
import fs from "node:fs/promises";
import os from "node:os";
import path3 from "node:path";
import process16 from "node:process";

// test/utils.ts
import { Readable, Writable } from "node:stream";

class MockWritable extends Writable {
  buffer = [];
  _write(chunk, encoding, callback) {
    this.buffer.push(chunk.toString());
    callback();
  }
}

class MockReadable extends Readable {
  _buffer = [];
  _read() {
    if (this._buffer === null) {
      this.push(null);
      return;
    }
    for (const val of this._buffer) {
      this.push(val);
    }
    this._buffer = [];
  }
  pushValue(val) {
    this._buffer?.push(val);
  }
  close() {
    this._buffer = null;
  }
}

// src/testing.ts
function createTestCLI(options = {}) {
  return cli(options.name || "");
}
function setupTest() {
  const stdout3 = new MockWritable;
  const stderr = new MockWritable;
  const stdin3 = new MockReadable;
  const originalExit = process16.exit;
  const originalStdout = process16.stdout;
  const originalStderr = process16.stderr;
  const originalStdin = process16.stdin;
  const originalConsoleLog = console.log;
  process16.exit = (code) => {
    throw new Error(`Process exit with code: ${code || 0}`);
  };
  Object.defineProperty(process16, "stdout", { value: stdout3, writable: true });
  Object.defineProperty(process16, "stderr", { value: stderr, writable: true });
  Object.defineProperty(process16, "stdin", { value: stdin3, writable: true });
  return {
    stdout: stdout3,
    stderr,
    stdin: stdin3,
    originalExit,
    originalStdout,
    originalStderr,
    originalStdin,
    originalConsoleLog
  };
}
function teardownTest(context) {
  process16.exit = context.originalExit;
  Object.defineProperty(process16, "stdout", { value: context.originalStdout, writable: true });
  Object.defineProperty(process16, "stderr", { value: context.originalStderr, writable: true });
  Object.defineProperty(process16, "stdin", { value: context.originalStdin, writable: true });
  console.log = context.originalConsoleLog;
}
async function execCommand(cliInstance, argv, options = {}) {
  const startTime = Date.now();
  const { inputs = [], env = {}, cwd = process16.cwd(), timeout = 5000 } = options;
  const testContext = setupTest();
  const { stdin: stdin3, stdout: stdout3, stderr } = testContext;
  const isHelpCommand = argv.includes("--help") || argv.includes("-h");
  const capturedOutput = [];
  process16.stdout.write = function(chunk) {
    const str = chunk.toString();
    capturedOutput.push(str);
    stdout3.write(str);
    return true;
  };
  console.log = function(...args) {
    const str = args.map((arg) => String(arg)).join(" ");
    capturedOutput.push(`${str}
`);
    stdout3.write(`${str}
`);
    return;
  };
  if (inputs.length > 0) {
    for (const input of inputs) {
      stdin3.pushValue(`${input}
`);
    }
  }
  const originalEnv = { ...process16.env };
  const originalCwd = process16.cwd();
  Object.entries(env).forEach(([key, value]) => {
    process16.env[key] = value;
  });
  if (cwd !== originalCwd) {
    process16.chdir(cwd);
  }
  let result;
  let exitCode = 0;
  try {
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error("Command execution timed out")), timeout);
    });
    const runPromise = Promise.resolve().then(async () => {
      try {
        cliInstance.showHelpOnExit = false;
        cliInstance.showVersionOnExit = false;
        cliInstance.parse(["node", "cli", ...argv]);
        if (isHelpCommand) {
          cliInstance.outputHelp();
        }
        result = cliInstance.runMatchedCommand();
        return result;
      } catch (error) {
        exitCode = 1;
        stderr.write(`${error}
`);
        throw error;
      }
    });
    await Promise.race([runPromise, timeoutPromise]);
  } catch (error) {
    if (error.message === "Command execution timed out") {
      throw error;
    }
  } finally {
    process16.env = originalEnv;
    if (cwd !== originalCwd) {
      process16.chdir(originalCwd);
    }
    teardownTest(testContext);
  }
  const duration = Date.now() - startTime;
  if (isHelpCommand) {
    exitCode = 0;
  }
  return {
    stdout: capturedOutput.join(""),
    stderr: stderr.buffer.join(""),
    exitCode,
    duration,
    outputs: [...capturedOutput],
    result
  };
}
var mockPromptResponses = null;
function mockPrompt(responses) {
  mockPromptResponses = responses;
}
function getMockResponse(prompt) {
  if (!mockPromptResponses)
    return;
  if (prompt in mockPromptResponses) {
    return mockPromptResponses[prompt];
  }
  for (const [key, value] of Object.entries(mockPromptResponses)) {
    if (key.startsWith("/") && key.endsWith("/i")) {
      const pattern = key.slice(1, -2);
      const regex2 = new RegExp(pattern, "i");
      if (regex2.test(prompt)) {
        return value;
      }
    } else if (key.startsWith("/") && key.endsWith("/")) {
      const pattern = key.slice(1, -1);
      const regex2 = new RegExp(pattern);
      if (regex2.test(prompt)) {
        return value;
      }
    }
  }
  if ("*" in mockPromptResponses) {
    return mockPromptResponses["*"];
  }
  return;
}
function resetMockPrompts() {
  mockPromptResponses = null;
}
var captureInstance = null;
function captureOutput() {
  const stdout3 = [];
  const stderr = [];
  const originalStdoutWrite = process16.stdout.write;
  const originalStderrWrite = process16.stderr.write;
  process16.stdout.write = function(chunk) {
    stdout3.push(chunk.toString());
    return true;
  };
  process16.stderr.write = function(chunk) {
    stderr.push(chunk.toString());
    return true;
  };
  const instance = {
    stdout: stdout3,
    stderr,
    stop: () => {
      process16.stdout.write = originalStdoutWrite;
      process16.stderr.write = originalStderrWrite;
      captureInstance = null;
      return {
        stdout: stdout3.join(""),
        stderr: stderr.join("")
      };
    }
  };
  captureInstance = instance;
  return instance;
}
function getLastOutput() {
  if (!captureInstance) {
    throw new Error("No output capture in progress. Call captureOutput() first.");
  }
  return captureInstance.stdout.join("");
}
async function createTestFS(structure) {
  const testDir = await fs.mkdtemp(path3.join(os.tmpdir(), "clapp-test-"));
  const createNestedStructure = async (basePath, struct) => {
    for (const [key, value] of Object.entries(struct)) {
      const itemPath = path3.join(basePath, key);
      if (typeof value === "object" && !Buffer.isBuffer(value)) {
        if (key.endsWith("/")) {
          await fs.mkdir(itemPath, { recursive: true });
          await createNestedStructure(itemPath, value);
        } else {
          await fs.mkdir(itemPath, { recursive: true });
          await createNestedStructure(itemPath, value);
        }
      } else {
        const parentDir = path3.dirname(itemPath);
        await fs.mkdir(parentDir, { recursive: true });
        if (Buffer.isBuffer(value)) {
          await fs.writeFile(itemPath, value);
        } else if (typeof value === "string") {
          await fs.writeFile(itemPath, value, "utf8");
        } else {
          await fs.writeFile(itemPath, JSON.stringify(value), "utf8");
        }
      }
    }
  };
  await createNestedStructure(testDir, structure);
  return testDir;
}
async function cleanupTestFS(testDir) {
  const deleteDirRecursive = async (dir) => {
    const items = await fs.readdir(dir, { withFileTypes: true });
    for (const item of items) {
      const itemPath = path3.join(dir, item.name);
      if (item.isDirectory()) {
        await deleteDirRecursive(itemPath);
      } else {
        await fs.unlink(itemPath);
      }
    }
    await fs.rmdir(dir);
  };
  await deleteDirRecursive(testDir);
}
// src/index.ts
var src_default = cli;
export {
  updateSettings,
  unicodeOr,
  unicode,
  text,
  teardownTest,
  tasks,
  taskLog,
  table,
  symbol,
  style,
  stream,
  spinner,
  setupTest,
  settings,
  setTheme,
  setRawMode,
  setDotProp,
  setByType,
  setAccessibility,
  selectKey,
  select,
  scroll,
  resetMockPrompts,
  removeBrackets,
  progress,
  processMarkdown,
  path,
  password,
  panel,
  padRight,
  outro,
  note,
  multiselect,
  mockPrompt,
  log,
  limitOptions,
  isUnicodeSupported,
  isTTY,
  isCancel,
  isCI,
  isActionKey,
  intro,
  groupMultiselect,
  group,
  getMriOptions,
  getMockResponse,
  getLastOutput,
  getFileName,
  getColumns,
  findLongest,
  findAllBrackets,
  execCommand,
  erase,
  diffLines,
  src_default as default,
  cursor,
  createTestFS,
  createTestCLI,
  confirm,
  codes,
  cli,
  clear,
  cleanupTestFS,
  captureOutput,
  cancel,
  camelcaseOptionName,
  camelcase,
  box,
  block,
  beep,
  autocompleteMultiselect,
  autocomplete,
  S_WARN,
  S_SUCCESS,
  S_STEP_SUBMIT,
  S_STEP_ERROR,
  S_STEP_CANCEL,
  S_STEP_ACTIVE,
  S_RADIO_INACTIVE,
  S_RADIO_ACTIVE,
  S_PASSWORD_MASK,
  S_INFO,
  S_ERROR,
  S_CORNER_TOP_RIGHT,
  S_CORNER_BOTTOM_RIGHT,
  S_CONNECT_LEFT,
  S_CHECKBOX_SELECTED,
  S_CHECKBOX_INACTIVE,
  S_CHECKBOX_ACTIVE,
  S_BAR_START,
  S_BAR_H,
  S_BAR_END,
  S_BAR,
  GlobalCommand,
  ESC,
  Command,
  ClappError,
  CSI,
  CLI,
  CANCEL_SYMBOL
};
